import React, { useState, useEffect, Component } from 'react';
import { Layout, Menu, Avatar, Input, Button, Result } from 'antd';
import { BrowserRouter as Router1, HashRouter as Router, Route, Link, useParams, useLocation } from "react-router-dom";
import './app.css';
import logo from './aquax.jpg';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { EmployeeRolesEnum, GlobalVariableValues, UiConfig } from '@gtpl/shared-models/common-models';
import { TransactionOutlined, UserOutlined, AccountBookOutlined, EyeOutlined, ProfileOutlined, AppstoreAddOutlined, DeleteOutlined, HistoryOutlined, PlusSquareOutlined, AppstoreOutlined, EnvironmentOutlined, LaptopOutlined, NotificationOutlined, DeliveredProcedureOutlined, DatabaseOutlined, CarOutlined, TeamOutlined, PieChartOutlined, MoneyCollectOutlined, DashboardOutlined, GoldOutlined, SelectOutlined, CarryOutOutlined, PicCenterOutlined, FileProtectOutlined, SnippetsOutlined, TableOutlined, EditOutlined, HomeOutlined, HomeFilled, FrownTwoTone, InsertRowLeftOutlined, FontColorsOutlined, UserDeleteOutlined, SubnodeOutlined, PercentageOutlined, BankOutlined, GlobalOutlined, ExclamationCircleOutlined, FileExcelOutlined, TagsOutlined, PrinterOutlined, TagOutlined, UsergroupAddOutlined, IdcardOutlined, AlignLeftOutlined } from '@ant-design/icons';
import { StarOutlined, CalendarOutlined, StarFilled, FormOutlined, SettingOutlined, StarTwoTone, SolutionOutlined, MenuFoldOutlined, ContainerOutlined, MenuUnfoldOutlined, ExportOutlined, GroupOutlined, FundProjectionScreenOutlined, FilePptOutlined, DropboxOutlined, FundViewOutlined, ReadOutlined, FileDoneOutlined, ScheduleOutlined, ImportOutlined, BookOutlined, DownloadOutlined, RiseOutlined, ExperimentTwoTone, MonitorOutlined, FileSyncOutlined, ExceptionOutlined, InteractionOutlined, InteractionFilled, WhatsAppOutlined, MessageOutlined, ScanOutlined, UserAddOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { LocationMappingForm } from '@gtpl/pages/procurement/packing-materials-components/location-mapping-form';
import { SaleOrderProcessTypesForm } from '@gtpl/pages/master/master-components/sale-order-status-types-form';
import { SaleOrderProcessTypesGrid } from '@gtpl/pages/master/master-components/sale-order-status-types-grid';
import { SaleOrderTypesForm } from '@gtpl/pages/master/master-components/sale-order-types-form';
import { SaleOrderTypesGrid } from '@gtpl/pages/master/master-components/sale-order-types-grid';
import { StoreConsumptionForm, StoreIssuesForm } from '@gtpl/pages/procurement/packing-materials-components/store-consumption-form';
import { StoreConsumptionDetailView } from '@gtpl/pages/procurement/packing-materials-components/store-consumption-detail-view';

import { GrnDetailviewGrid } from '@gtpl/pages/procurement/packing-materials-components/grn-detailview-grid';

import { BomParameterGrid } from '@gtpl/pages/sale-management/sale-components/bom-parameter-grid';
import { BomParameter } from '@gtpl/pages/sale-management/sale-pages/bom-parameter';
import { BomParameterDetailView } from '@gtpl/pages/sale-management/sale-components/bom-parameter-grid';

import { StoreReturnGrid, StoreReturnDetailView } from '@gtpl/pages/procurement/packing-materials-components/store-return-grid';
import { PoDetailViewPages, PoPrint } from '@gtpl/pages/procurement-masters/procurement-master-pages/po-detail-view-pages';
import { TransferPrint } from "@gtpl/pages/procurement/packing-materials-components/transfer-print";
import { GrnReturnDetailView } from "@gtpl/pages/procurement/packing-materials-components/grn-return-grid";
import { PackingStockTransfer, WhatsAppBroadCast } from "@gtpl/pages/procurement/packing-materials-components/stock-transfer";
import { ReportingForm } from '@gtpl/pages/warehouse-management/warehouse-components/reporting-form';
import { GeneratePickList } from '@gtpl/pages/warehouse-management/warehouse-components/stock-out';
import { CommonInvoice, CusInvoice, CommonPackingList, ShippingInstructions, PackingList, CommercialPackingList, CommercialInvoice, InsuranceUpload, FreigstInvoice, TaxInvoice, PlantInvoice, PlantPackingList, IsfWorksheet } from '@gtpl/pages/logistics/logistics-components/documents';
import { WorkstationsForm } from '@gtpl/pages/production-management/production-management-components/workstations-form';
import { SoakingReporting } from '@gtpl/pages/production-management/production-management-components/soaking-reporting';
import { SoakingTubBulbIntegration } from '@gtpl/pages/production-management/production-management-components/soaking-dashboard';
import { SoakingMaterialDetailView } from '@gtpl/pages/production-management/production-management-components/soaking-material-detail-view';
import { SubPlantValAdditionsReport } from '@gtpl/pages/production-management/production-management-components/sub-plant-val-additions-report';
import { BeheadingSubPlantHistory } from '@gtpl/pages/production-management/production-management-components/beheading-sub-plant-history'
import { ReportSubPlantOperations } from '@gtpl/pages/production-management/production-management-components/report-sub-plant-operations';
import { SendAndReceiveTransactions } from '@gtpl/pages/production-management/production-management-components/receive-sub-plants-stock';
import { OperationsRegister } from '@gtpl/pages/reports/reports-components/operations-register';
import { QaQcSampleDetailView } from '@gtpl/pages/qa-qc/qa-qc-components/qa-qc-sample-detail-view'
import { otDetails } from '@gtpl/pages/hrms/hrms-components/self-service-portal';
import { CodeListPrint } from '@gtpl/pages/planning/planning-components/code-list-grid';
import { SoInfoView } from '@gtpl/pages/sale-management/sale-pages/so-info-view';
import { SoInfoViewPages } from '@gtpl/pages/sale-management/sale-pages/so-info-view-pages';
import { dispatchlistgrid } from '@gtpl/pages/warehouse-management/warehouse-components/dispatch-list-grid';
import { StockTransferDetailView } from '@gtpl/pages/procurement/packing-materials-components/stock-transfer-detail-view';
import { BlanchingCookingForm } from '@gtpl/pages/production-management/production-management-components/blanching-cooking-form';
import { ShippmentDetailsForm, ShippmentDetailsReceivedTabForm } from '@gtpl/pages/logistics/logistics-components/shippment-details-form';
import { CodeListDetailView } from '@gtpl/pages/planning/planning-components/code-list-main-grid';
import { DownTimeTrackingForm } from '@gtpl/pages/master/master-components/down-time-tracking-form';
import { faArrowUpShortWide, faCartShopping, faCertificate, faCode, faCommentSlash, faDiceFive, faDiceFour, faDiceOne, faDiceThree, faDiceTwo, faFileCircleQuestion, faIdBadge, faMoneyBillWaveAlt, faNetworkWired, faNewspaper, faPersonCircleCheck, faRuler, faShrimp, faTemperatureHalf, faUsers, faUsersRays, faUtensils, faUtensilSpoon, faGlobe, faLocationDot, faDollarSign, faBoxesPacking, faMoneyBill, faCashRegister, faTruck, faPeopleGroup, faMemory, faHouse, faCheck, faClipboard, faPeopleArrows, faHouseCrack, faUserGroup, faBuildingCircleArrowRight, faLocationPin, faMoneyCheckDollar, faComputer, faPersonWalkingDashedLineArrowRight, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket, faArrowRightToBracket, faArrowsRotate, faBook, faBoxesStacked, faBoxOpen, faCartFlatbedSuitcase, faColumns, faFile, faFileCircleCheck, faFileInvoice, faFileLines, faPallet, faSnowflake, faTruckFast, faTruckLoading, faTruckPickup, faWarehouse } from '@fortawesome/free-solid-svg-icons';
import { TemperatureLogForm } from '@gtpl/pages/dashboard/dashboard-components/temperature-log'
import { VisitorDetailedView } from 'libs/pages/visitor-management/visitor-components/visitor-request-form/src/lib/visitor-detailed-view';
import { AssetLocationMapping } from 'libs/pages/asset-management/asset-management-components/asset-classification-grid/src/lib/pages-asset-management-asset-management-components-asset-classification-grid';
import { locationForm } from 'libs/pages/asset-management/asset-management-components/dc-form/src/lib/pages-asset-management-asset-management-components-dc-form';
import { AssetLocation } from 'libs/pages/asset-management/asset-management-components/dc-grid/src/lib/pages-asset-management-asset-management-components-dc-grid';
import UsersRouting from './user-routing';
import ReportsRouting from './repoprts-roting';
import DowntimeRouting from './downtime-routing';
import PackingRouting from './packing-routing';
import { HrmsRoute } from './hrms-routing';
import { LogisticsRoute } from './logistics-routing';
import { WarehouseRoute } from './warehouse-routing';
import { RmProcurementRoute } from './rm-procurement-routing';
import { DashboardRouting } from './dashboard-routing';
import { SalesRoute } from './sales-routing';
import { MastersRoute } from './masters-routing';
import { ProductionRouting } from './production-routing';
import { QaQcRouting } from './qa-qc-routing';
import { AssetManagementRouting } from './asset-management-routing';
// import { PackingDashboard } from '@gtpl/pages/procurement/packing-materials-components/packing-dashboard';
import { UnitTypeEnum } from '@gtpl/shared-models/masters';
import { LotDetailView } from '@gtpl/pages/production-management/production-management-components/lot-detail-view';
import { VmsRouting } from './vms-routing';
import CmsRouting from './cms-routing';
import { InquiryForm } from '@gtpl/pages/inquiry-management/inquiry-components/inquiry'
import { employeeReport } from '@gtpl/pages/canteen-management/canteen-management-components/freebies-grid';
import { WhatsAppUsageReport } from '@gtpl/pages/logistics/logistics-components/container-register';
let timer
const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
];

const { Header, Sider, Content, Footer }: any = Layout;
export const BasicLayout = React.memo((props: any) => {


    const [collapsed, setcollapsed] = useState(true);
    const [selectedMenu, setselectedMenu] = useState('/');
    const [subMenu, setSubmenu] = useState([]);
    const [username, setUserName] = useState<string>(props.username);

    if (props) {
        const [UserName, setUserName] = useState<string>();
    }

    const user_name_local = JSON.parse(localStorage.getItem('username'));
    console.log('role');
    console.log(localStorage.getItem('role'));
    const Search = Input.Search;
    const uiConfig = new UiConfig();

    useEffect(() => {
        console.log(JSON.parse(localStorage.getItem('role')));
        console.log(props.user);
        let href = window.location.href.split('/');
        setUserName(props.user.user_data.username);
        // localStorage.setItem("createdUser", 'Admin');
        const routeLink = href[3];
        if (routeLink) {
            setselectedMenu(routeLink);
            const rootMenus = ['mdm', 'sms', 'pps', 'pts'];
            if (!rootMenus.includes(routeLink)) {
                if (routeLink === 'plantCalendar' || routeLink === 'editPlantCalendar') {
                    setSubmenu(['subPlantCalendarMenu', 'pms'])
                } else {
                    setSubmenu(['pms'])
                }
            }
        } else {
            setSubmenu(['pms'])
            setselectedMenu('/');
        }
    }, [])

    const [loading, setLoading] = useState(true)

    // when component mounts, it adds an event listeners to the window
    // each time any of the event is triggered, i.e on mouse move, click, scroll, keypress etc, the timer to logout user after 10 secs of inactivity resets.
    // However, if none of the event is triggered within 10 secs, that is app is inactive, the app automatically logs out.
    useEffect(() => {
        Object.values(events).forEach((item) => {
            window.addEventListener(item, () => {
                resetTimer();
                handleLogoutTimer();
            });
        });
    }, []);

    useEffect(() => {
        setTimeout(() => setLoading(false), 1000)
    }, [])

    const resetTimer = () => {
        if (timer) clearTimeout(timer);
    };

    // this function sets the timer that logs out the user after 10 secs
    const handleLogoutTimer = () => {
        timer = setTimeout(() => {
            // clears any pending timer.
            resetTimer();
            // Listener clean up. Removes the existing event listener from the window
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer);
            });
            // logs out user
            logOut();
        }, 7200000); // 10000ms = 10secs. You can change the time.  900000...15min after 15 min automatically will log out
    };



    const menu = (e) => {
        if (e.keyPath.length < 2) {
            setSubmenu([])
            setselectedMenu(e.key)
        } else {
            setSubmenu(e.keyPath)
            setselectedMenu(e.key)
        }
    }
    const { SubMenu } = Menu;
    const toggle = () => {
        setcollapsed(!collapsed);
    }

    const onOpenChange = (openKeys: string[]) => {
        setSubmenu(openKeys)
    }

    const logOut = () => {
        localStorage.clear();
        window.location.reload();
        AlertMessages.getSuccessMessage('Logging out');

    }

    const role = JSON.parse(localStorage.getItem('role'));

    const ifNotHaveAccess = () => {
        return <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
        // extra={<Link to='' ><Button type="primary">Back Home</Button></Link>}
        />
    }

    return (<Layout className="layout">
        <Router>

            <Sider breakpoint="lg" collapsedWidth="80" className='noprint'
                style={{
                    overflow: 'auto',
                    height: '100vh',
                    position: 'fixed',
                    left: 0,
                }}
                collapsible
                onCollapse={(collapsed, type) => {
                    setcollapsed(true);
                }} collapsed={collapsed} trigger={null}>
               <div 
                className="logo" 
                style={{ width: collapsed ? '76px' : 'auto', transition: 'width 0.3s' }}
                > 
                <img
                        src={logo} 
                        alt="Logo"
                        style={{ 
                            width: collapsed ? '75%' : '80%', 
                            marginLeft: collapsed ? '0' : '18px', 
                            height: collapsed ? '35px' : '38px', 
                            transition: 'all 0.3s' 
                        }} 
                    />
                    {/* Display the name when not collapsed */}
                    {/* <h1 style={{ display: collapsed ? 'none' : 'block' }}>AquaX</h1> */}
                </div>
                <Menu theme="dark" mode="inline"
                    onClick={menu}
                    openKeys={subMenu}
                    defaultOpenKeys={[]} style={{ paddingTop: "20px" }}
                    selectedKeys={[selectedMenu]}
                    onOpenChange={onOpenChange}
                    defaultSelectedKeys={['/']} >
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                          <Menu.Item key="whatsapp-usage-report" icon={<AlignLeftOutlined  />}>
                            <Link to="/whatsapp-usage-report"><span>Usage Report</span></Link>
                        </Menu.Item>

                    }
                        

                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                        <SubMenu
                            key="user-management" icon={<UserOutlined />}
                            title={
                                <span>
                                    <span>Users</span>
                                </span>
                            }
                        >
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <>
                                    <Menu.Item key="ums-grid" icon={<UserOutlined />}>
                                        <Link to="/user-grid"><span>Users</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="supplier-creation" icon={<UsergroupAddOutlined />}>
                                        <Link to="/supplier-creation"><span>Supplier Creation</span></Link>
                                    </Menu.Item>
                                </>}
                        </SubMenu>
                    }
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                        <SubMenu
                            key="dashboards" icon={<PieChartOutlined />}
                            title={
                                <span>
                                    <span>Dashboards</span>
                                </span>
                            }
                        >
                             {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <>
                            <Menu.Item key="ceo-dashboard" icon={<ContainerOutlined />}>
                                <Link to="/ceo-dashboard"><span>CEO Dashboard</span></Link>
                            </Menu.Item>
                            </>}
                             {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) ||(JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                                <>
                            <Menu.Item key="rm-dashboard" icon={<ContainerOutlined />}>
                                <Link to="/rm-dashboard"><span>RM Dashboard</span></Link>
                            </Menu.Item>
                            </>}
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&
                            <>
                            <Menu.Item key="dashboard" icon={<MoneyCollectOutlined />}>
                                    <Link to="/dashboard"><span>Sales Dashboard</span></Link>
                                </Menu.Item>
                             </>} 
                             {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER)) &&
                            <> 
                            <Menu.Item key="packing-dashboards" icon={<DropboxOutlined />}>
                                <Link to="/packing-dashboards"><span>Packing Dashboard</span></Link>
                            </Menu.Item>
                            </>}
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER))  &&
                            <> 
                                    <Menu.Item key="logistics-dashboard" icon={<FontAwesomeIcon icon={faTruckFast} />}>
                                    <Link to="/logistics-dashboard"><span>logistics dashboard</span></Link>
                                </Menu.Item>
                                </>}
                                {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)) &&
                            <> 
                                <Menu.Item key="/wh-dashboard-components" icon={<FontAwesomeIcon icon={faWarehouse} />}>
                                    <Link to="/wh-dashboard-components"><span>WH Dashboard</span></Link>
                                </Menu.Item> 
                                </>}
                                {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                               <> 
                          
                                <Menu.Item key="production-process-dashboard" icon={<MoneyCollectOutlined />}>
                                    <Link to="/production-process-dashboard"><span>Production Dashboard</span></Link>
                                </Menu.Item> 
                                </>}
                            {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <Menu.Item key="fh-dashboard-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/fh-dashboard-grid"><span>Factory Head</span></Link>
                                </Menu.Item>
                            } */}

                            {/* {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <Menu.Item key="dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/dashboard"><span>Sales Dashboard</span></Link>
                                </Menu.Item>
                            } */}
                             
                            {/* {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <>
                                <Menu.Item key="down-time-dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/down-time-dashboard"><span>DownTime Dashboard</span></Link>
                                </Menu.Item>
                                    <Menu.Item key="rm-dashboard" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-dashboard"><span>Rm Dashboard</span></Link>
                                    </Menu.Item> 
                                    
                                </>
                            } */}

                            {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <Menu.Item key="lot-code-dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/lot-code-dashboard"><span>LotCode Dashboard</span></Link>
                                </Menu.Item>} */}

                            {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <>
                                    <Menu.Item key="packing-dashboards" icon={<PicCenterOutlined />}>
                                        <Link to="/packing-dashboards"><span>Packing Dashboard</span></Link>
                                    </Menu.Item>
                                </>
                            } */}
{/* 
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <Menu.Item key="logistics-dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/logistics-dashboard"><span>logistics dashboard</span></Link>
                                </Menu.Item>} */}
{/* 
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <Menu.Item key="/wh-dashboard-components" icon={<PicCenterOutlined />}>
                                    <Link to="/wh-dashboard-components"><span>WH Dashboard</span></Link>
                                </Menu.Item>} */}
{/* 
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <Menu.Item key="dept-wise-attn" icon={<PicCenterOutlined />}>
                                    <Link to="/dept-wise-attn"><span>Attendance Dashboard</span></Link>
                                </Menu.Item>} */}

                            {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <Menu.Item key="recruitment-dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/recruitment-dashboard"><span>recruitment dashboard</span></Link>
                                </Menu.Item>}

                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <Menu.Item key="employee-dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/employee-dashboard"><span>Employee dashboard</span></Link>
                                </Menu.Item>}

                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <Menu.Item key="users-dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/users-dashboard"><span>Users dashboard</span></Link>
                                </Menu.Item>} */}

                        </SubMenu>
                    }
                    {(([
                        EmployeeRolesEnum.ADMIN,
                        EmployeeRolesEnum.NAVTECH_WH,
                        EmployeeRolesEnum.ASSISTANT_SALES_MANAGER,
                        EmployeeRolesEnum.SR_SALES_MANAGER,
                        EmployeeRolesEnum.PLANT_SALES_MANAGER,
                        EmployeeRolesEnum.HO_SALES_MANAGER,
                        EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                        EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                        EmployeeRolesEnum.DOCUMENTATION_MANAGER,
                        EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER,
                        EmployeeRolesEnum.PACKAGING_SUPERVISOR,
                        EmployeeRolesEnum.SUPER_ADMIN,
                        EmployeeRolesEnum.FINANCE_PERSON,
                        EmployeeRolesEnum.QAQC_PERSON,
                        EmployeeRolesEnum.INDENT_PERSON,
                        EmployeeRolesEnum.ENQUIRY_PERSON,
                        EmployeeRolesEnum.WAREHOUSE_MANAGER,
                        EmployeeRolesEnum.PRODUCTION_PERSON,
                        EmployeeRolesEnum.REWEIGHTMENT_PERSON,








                        
                    ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1)
                        &&
                        <SubMenu
                            key="masters" icon={<UserOutlined />}
                            title={
                                <span>
                                    <span>Masters</span>
                                </span>
                            }
                        >
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&

                                <SubMenu
                                    key="global_masters" icon={<GlobalOutlined />}
                                    title={
                                        <span>
                                            <span>Global</span>
                                        </span>
                                    }
                                >
                                    {
                                        ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) && <>
                                            <Menu.Item key="certificates-view" icon={<FontAwesomeIcon icon={faCertificate} />}>
                                                <Link to="/certificates-view"><span>Certificates</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="Countries-view" icon={<FontAwesomeIcon icon={faGlobe} />}>
                                                <Link to="/Countries-view"><span>Countries</span></Link>
                                            </Menu.Item>

                                            {/* 
                                    <Menu.Item key="DownTimeReason-view" icon={<PicCenterOutlined />}>
                                        <Link to="/DownTimeReason-view"><span>DownTimeReason</span></Link>
                                    </Menu.Item> */}
                                            <Menu.Item key="destination-view" icon={<FontAwesomeIcon icon={faLocationDot} />}>
                                                <Link to="/destination-view"><span>Destination</span></Link>
                                            </Menu.Item>

                                            <Menu.Item key="Currencies-view" icon={<FontAwesomeIcon icon={faDollarSign} />}>
                                                <Link to="/Currencies-view"><span>Currencies</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="customers-view" icon={<FontAwesomeIcon icon={faPeopleGroup} />}>
                                                <Link to="/customers-view"><span>Customers</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="delivery-terms-view" icon={<FontAwesomeIcon icon={faTruck} />}>
                                                <Link to="/delivery-terms-view"><span>Delivery Terms</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="packingmethods-view" icon={<FontAwesomeIcon icon={faBoxesPacking} />}>
                                                <Link to="/Packingmethods-view"><span>Packing Methods</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="Payment-modes-view" icon={<FontAwesomeIcon icon={faMoneyBill} />}>
                                                <Link to="/Payment-modes-view"><span>Payment Modes</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="payment-terms-view" icon={<FontAwesomeIcon icon={faCashRegister} />}>
                                                <Link to="/payment-terms-view"><span>Payment Terms</span></Link>
                                            </Menu.Item>

                                            <Menu.Item key="shipping-terms-view" icon={<FontAwesomeIcon icon={faTruckFast} />}>
                                                <Link to="/shipping-terms-view"><span>Shipping Terms</span></Link>
                                            </Menu.Item>

                                            <Menu.Item key="taxes-view" icon={<FontAwesomeIcon icon={faClipboard} />}>
                                                <Link to="/taxes-view"><span>Taxes</span></Link>
                                            </Menu.Item>


                                            <Menu.Item key="UOMs-view" icon={<PicCenterOutlined />}>
                                                <Link to="/UOMs-view"><span>UOMs</span></Link>
                                            </Menu.Item>

                                            <Menu.Item key="unitcode-view" icon={<FontAwesomeIcon icon={faHouse} />}>
                                                <Link to="/unitcode-view"><span>Plants</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="bank-details-view" icon={<BankOutlined />}>
                                                <Link to="/bank-details-view"><span>Bank Details</span></Link>
                                            </Menu.Item>
                                        </>

                                    }

                                    {
                                        ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) && <>


                                            <Menu.Item key="/insurance-view" icon={<FontAwesomeIcon icon={faHouseCrack} />}>
                                                <Link to="/insurance-view"><span>Insurance Details</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="/notify-party-grid" icon={<FontAwesomeIcon icon={faCheck} />}>
                                                <Link to="/notify-party-grid"><span>Notify Party</span></Link>
                                            </Menu.Item>

                                            <Menu.Item key="/stock-item-category-view" icon={<PicCenterOutlined />}>
                                                <Link to="/stock-item-category-view"><span>Stock Item Category</span></Link>
                                            </Menu.Item>

                                        </>
                                    }
                                </SubMenu>
                            }
                            {/* Global Masters Ending */}
                            {/* Sales Masters Starting */}
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SR_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)) &&
                                <SubMenu
                                    key="sales_masters" icon={<MoneyCollectOutlined /> }
                                    title={
                                        <span>
                                            <span>Sales</span>
                                        </span>
                                    }
                                >
                                    {
                                        ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) ||
                                            (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) &&

                                        <Menu.Item key="master-brands-grid" icon={<FontAwesomeIcon icon={faCertificate} />}>
                                            <Link to="/master-brands-grid"><span>Brands</span></Link>
                                        </Menu.Item>}

                                    {
                                        ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)) && <>


                                            <Menu.Item key="EndCustomerView" icon={<FontAwesomeIcon icon={faUsers} />} >
                                                <Link to="/EndCustomerview" >
                                                    <span>End Customer</span>
                                                </Link>
                                            </Menu.Item>
                                            <Menu.Item key="Grades-view" icon={<FontAwesomeIcon icon={faArrowUpShortWide} />}>
                                                <Link to="/Grades-view"><span>Grade</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="typeofFood-view" icon={<FontAwesomeIcon icon={faShrimp} />}>
                                                <Link to="/typeofFood-view"><span>Food Type</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="products-view" icon={<FontAwesomeIcon icon={faCartShopping} />}>
                                                <Link to="/Products-view"><span>Products</span></Link>
                                            </Menu.Item>

                                            <Menu.Item key="spec-sheet" icon={<FontAwesomeIcon icon={faUsers} />} >
                                                <Link to="/specsheet-view" >
                                                    <span>Spec Sheet</span>
                                                </Link>
                                            </Menu.Item>

                                            <Menu.Item key="valueaddition1-view" icon={<FontAwesomeIcon icon={faDiceOne} />}>
                                                <Link to="/valueaddition1-view"><span>Val Addn1</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="valueaddition2-view" icon={<FontAwesomeIcon icon={faDiceTwo} />}>
                                                <Link to="/valueaddition2-view"><span>Val Addn2</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="valueaddition3-view" icon={<FontAwesomeIcon icon={faDiceThree} />}>
                                                <Link to="/valueaddition3-view"><span>Val Addn3</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="valueaddition4-view" icon={<FontAwesomeIcon icon={faDiceFour} />}>
                                                <Link to="/valueaddition4-view"><span>Val Addn4</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="valueaddition5-view" icon={<FontAwesomeIcon icon={faDiceFive} />}>
                                                <Link to="/valueaddition5-view"><span>Val Addn5</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="sku-view" icon={<PicCenterOutlined />}>
                                                <Link to="/sku-view"><span>Product SKU's</span></Link>
                                            </Menu.Item>

                                            <Menu.Item key="hsn-view" icon={<FontAwesomeIcon icon={faCode} />}>
                                                <Link to="/hsn-view"><span>HSN Code</span></Link>
                                            </Menu.Item> </>
                                    }
                                </SubMenu>
                            }

                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                                <SubMenu
                                    key="rm_masters" icon={<ContainerOutlined />}
                                    title={
                                        <span>
                                            <span>Raw Material</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="hatcheries-view" icon={<FontAwesomeIcon icon={faWarehouse} />}>
                                        <Link to="/hatcheries-view"><span>Hatcheries</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="hl-percentage-view" icon={<PercentageOutlined />}>
                                        <Link to="/hl-percentage-view"><span>HL Percentages</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="suppliers-view" icon={<UserOutlined />}>
                                        <Link to="/suppliers-view"><span>Farmers</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rm-tolerance-view" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-tolerance-view"><span>Rm Tolerance</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="defect-grid" icon={<ExclamationCircleOutlined /> }>
                                        <Link to="/defect-grid"><span>Defects</span></Link>
                                    </Menu.Item>


                                    {/* <Menu.Item key="rm-count-pricelist-grid" icon={<AccountBookOutlined  />}>
                                    <Link to="/rm-count-pricelist-grid"><span>RM Count PriceList</span></Link>
                                </Menu.Item> */}
                                    <Menu.Item key="rm-count-pricelist-form" icon={<AccountBookOutlined />}>
                                        <Link to="/rm-count-pricelist-form"><span>RM Count PriceList</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="farmers-view" icon={<FileExcelOutlined />}>
                                        <Link to="/farmers-view"><span>Farmers Excel upload</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON)) &&
                                <SubMenu
                                    key="transport_masters" icon={<FontAwesomeIcon icon={faTruck}/>}
                                    title={
                                        <span>
                                            <span>Transportation</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="vehicles" icon={<FontAwesomeIcon icon={faTruck} />}>
                                        <Link to="/vehicles"><span>Vehicles</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)) &&
                                <SubMenu
                                    key="enquiry_masters" icon={<PicCenterOutlined />}
                                    title={
                                        <span>
                                            <span>Enquiry</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="exchange-rate-grid" icon={<TransactionOutlined />}>
                                        <Link to="/exchange-rate-grid"><span>Exchange Rate</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="Fixed-components-rate-chart-view" icon={<MoneyCollectOutlined />}>
                                        <Link to="/Fixed-components-rate-chart-view">Fixed Components Rate Chart<span></span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="Fg-pricelist-view" icon={<MoneyCollectOutlined />}>
                                        <Link to="/Fg-pricelist-view"><span>Product Rate Chart</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="credit-print" icon={<PrinterOutlined />}>
                                        <Link to="/credit-print"><span>credit-print</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="global-price-chart" icon={<MoneyCollectOutlined />}>
                                        <Link to="/global-price-chart"><span>Price Chart</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="freights-company-view" icon={<MoneyCollectOutlined />}>
                                        <Link to="/freights-company-view"><span>Liners</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="ocaen-freight-rates-view" icon={<PicCenterOutlined/>}>
                                        <Link to="/ocaen-freight-rates-view"><span>Ocaen Freight Rate</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="farmers-view" icon={<UserOutlined />}>
                                        <Link to="/farmers-view"><span>Farmers</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="packing-material-prices-view" icon={<TagsOutlined />}>
                                        <Link to="/packing-material-prices-view"><span>Packing Material Prices</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="deheading-peeling-form" icon={<TagOutlined />}>
                                        <Link to="/deheading-peeling-form"><span>Peeling Rates</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }
                            {((
                                [
                                    EmployeeRolesEnum.ADMIN,
                                    EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                    EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                                    EmployeeRolesEnum.PACKAGING_SUPERVISOR,
                                    EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER
                                ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                <SubMenu
                                    key="procurement_masters" icon={<DropboxOutlined />}
                                    title={
                                        <span>
                                            <span>Packing</span>
                                        </span>
                                    }
                                >
                                    {((
                                        [
                                            EmployeeRolesEnum.ADMIN,
                                            EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                            EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                                            EmployeeRolesEnum.PACKAGING_SUPERVISOR,
                                            EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER
                                        ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            {((
                                                [
                                                    EmployeeRolesEnum.ADMIN,
                                                    EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                                    EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                                                    EmployeeRolesEnum.PACKAGING_SUPERVISOR,
                                                    EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER
                                                ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                                <>
                                                    <Menu.Item key="grn-rejection-reason-view" icon={<FontAwesomeIcon icon={faFileCircleQuestion} />}>
                                                        <Link to="/grn-rejection-reason-view"><span>GRN Rejection Reason</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="item-category-view" icon={<FontAwesomeIcon icon={faNewspaper} />}>
                                                        <Link to="/item-category-view"><span>Item Categories</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="item-sub-category-view" icon={<FontAwesomeIcon icon={faNetworkWired} />}>
                                                        <Link to="/item-sub-category-view"><span>Item Sub Categories</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="item-damage-reasons-view" icon={<FontAwesomeIcon icon={faNetworkWired} />}>
                                                        <Link to="/item-damage-reasons-view"><span>Item Damage Reasons</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="sizes-view" icon={<FontAwesomeIcon icon={faRuler} />}>
                                                        <Link to="/sizes-view"><span>Sizes</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="items-view" icon={<FontAwesomeIcon icon={faNewspaper} />}>
                                                        <Link to="/items-view"><span>Items</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="vendorsView" icon={<FontAwesomeIcon icon={faUsersRays} />}>
                                                        <Link to="/vendorsView"><span>Vendors</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="reasonsView" icon={<FontAwesomeIcon icon={faCommentSlash} />}>
                                                        <Link to="/reasonsView"><span>Reasons</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="trims-configuration-grid" icon={<PicCenterOutlined />}>
                                                        <Link to="/trims-configuration-grid"><span>Trims Configuration</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="types-grid" icon={<PicCenterOutlined />}>
                                                        <Link to="/types-grid"><span>Types</span></Link>
                                                    </Menu.Item>
                                                </>}

                                            {(([
                                                EmployeeRolesEnum.ADMIN,
                                                EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                                EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                                                EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR
                                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                                <>
                                                    <Menu.Item key="rm-zones-grid" icon={<PicCenterOutlined />}>
                                                        <Link to="/rm-zones-grid"><span>RmZones</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="rm-level-grid" icon={<PicCenterOutlined />}>
                                                        <Link to="/rm-level-grid"><span>RmLevel</span></Link>
                                                    </Menu.Item>

                                                    <Menu.Item key="rm-columns-grid" icon={<PicCenterOutlined />}>
                                                        <Link to="/rm-columns-grid"><span>RmColumns</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="rm-rack-position" icon={<PicCenterOutlined />}>
                                                        <Link to="/rm-rack-position"><span>Rm Rack Position</span></Link>
                                                    </Menu.Item>
                                                    <Menu.Item key="rm-rack" icon={<PicCenterOutlined />}>
                                                        <Link to="/rm-rack-form"><span>Rm Racks</span></Link>
                                                    </Menu.Item>

                                                    <Menu.Item key="/vendor-banks-view" icon={<PicCenterOutlined />}>
                                                        <Link to="/vendor-banks-view"><span>Vendor Banks</span></Link>
                                                    </Menu.Item>


                                                </>
                                            }
                                        </>
                                    }

                                </SubMenu>
                            }


                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.NAVTECH_WH) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)) &&
                                <SubMenu
                                    key="warehouse_masters" icon={<FontAwesomeIcon icon={faWarehouse} />}
                                    title={
                                        <span>
                                            <span>Warehouse</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="zone" icon={<FontAwesomeIcon icon={faSnowflake} />}>
                                        <Link to="/zone"><span>Cold Storage</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="column" icon={<FontAwesomeIcon icon={faColumns} />}>
                                        <Link to="/column"><span>Columns</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="level" icon={<PicCenterOutlined />}>
                                        <Link to="/level"><span>Levels</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="locations" icon={<PicCenterOutlined />}>
                                <Link to="/locations"><span>Locations</span></Link>
                            </Menu.Item> */}
                                    <Menu.Item key="pallet" icon={<FontAwesomeIcon icon={faPallet} />}>
                                        <Link to="/pallet"><span>Pallets</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rack" icon={<InsertRowLeftOutlined />}>
                                        <Link to="/rack-master-grid"><span>Racks</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rack-position" icon={<PicCenterOutlined />}>
                                        <Link to="/rack-position"><span>Rack Position</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="rack-endCustomer-mapping" icon={<PicCenterOutlined />}>
                                        <Link to='/rack-endCustomer-mapping'><span>Rack End Customer Mapping</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="pallet-capacity-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/pallet-capacity-grid"><span>Pallet Capacity</span></Link>
                                    </Menu.Item>


                                </SubMenu>
                            }

                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                                <SubMenu
                                    key="masters_planning_module" icon={<DropboxOutlined />}
                                    title={
                                        <span>
                                            <span>Planning</span>
                                        </span>
                                    }
                                >

                                    <Menu.Item key="resource-op-efficiency-view" icon={<ScheduleOutlined />}>
                                        <Link to="/resource-op-efficiency-view"><span>Resource Operation Efficiency</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="plant-capacity-form" icon={<ScheduleOutlined />}>
                                        <Link to="/plant-capacity-form"><span>Plant Capacity</span></Link>
                                    </Menu.Item>

                                </SubMenu>}

                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)) &&
                                <SubMenu
                                    key="production" icon={<RiseOutlined />}
                                    title={
                                        <span>
                                            <span>Production</span>
                                        </span>
                                    }
                                >

                                    {/* 
                                    <Menu.Item key="downtimetracking-view" icon={<PicCenterOutlined />}>
                                        <Link to="/downtimetracking-view"><span>DownTime Tracking</span></Link>
                                    </Menu.Item> */}

                                    <Menu.Item key="varient-operations-form" icon={<PicCenterOutlined />}>
                                        <Link to="/varient-operations-form"><span>Variant Operations</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="workstation-category-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/workstation-category-grid"><span>Workstation Category</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/soakstyle-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/soakstyle-grid"><span>Soak Style</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="operations-view" icon={<PicCenterOutlined />}>
                                        <Link to="/operations-view"><span>Operations</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="workstations-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/workstations-grid"><span>Workstations</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="plant-operation-capacity-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/plant-operation-capacity-view"><span>plant-operation-capacity</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="grade-suggestion" icon={<PicCenterOutlined />}>
                                        <Link to="/grade-suggestion"><span>grade-suggestion</span></Link>
                                    </Menu.Item>

                                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)) &&
                                    <Menu.Item key="deheading-rates" icon={<PicCenterOutlined />}>
                                        <Link to="/deheading-rates"><span>Deheading-rates</span></Link>
                                    </Menu.Item>
                                       }
                                    <Menu.Item key="village-transport-cost" icon={<PicCenterOutlined />}>
                                        <Link to="/village-transport-cost"><span>Vilage-Transport-details</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="workers-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/workers-grid"><span>Workers</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }


                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON)) &&
                                <SubMenu
                                    key="qa_qc_masters" icon={<RiseOutlined />}
                                    title={
                                        <span>
                                            <span>QA QC</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="qa-qc-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/qa-qc-grid"><span>QA QC Operations</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="code-list-grid" icon={<ScheduleOutlined />}>
                                        <Link to="/code-list-grid"><span>Tracebilities</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="code-list-print" icon={<ScheduleOutlined />}>
                                    <Link to="/code-list-print"><span>Code print</span></Link>
                                </Menu.Item> */}
                                </SubMenu>

                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                                <SubMenu
                                    key="hrms_masters" icon={<UserOutlined />}
                                    title={
                                        <span>
                                            <span>HRMS</span>
                                        </span>
                                    }

                                >

                                    {/* <Menu.Item key="/certifications-view" icon={<PicCenterOutlined />}>
                                        <Link to="/certifications-view"><span>Certifications</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/complaints-view" icon={<PicCenterOutlined />}>
                                        <Link to="/complaints-view"><span>Complaints</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="department-view" icon={<PicCenterOutlined />}>
                                        <Link to="/department-view"><span>Departments</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/designation-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/designation-grid"><span>Designation</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="/educations-view" icon={<PicCenterOutlined />}>
                                        <Link to="/educations-view"><span>Education</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/employment-status-form" icon={<PicCenterOutlined />}>
                                        <Link to="/employment-status-form"><span>Employment Status </span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/expenses-category-view" icon={<PicCenterOutlined />}>
                                        <Link to="/expenses-category-view"><span>Expenses Category</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/expenses-sub-category-view" icon={<PicCenterOutlined />}>
                                        <Link to="/expenses-sub-category-view"><span>Expenses Sub Category</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="/holidays-calendar-view" icon={<PicCenterOutlined />}>
                                        <Link to="/holidays-calendar-view"><span>Holidays Calendar</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="id-proofs-grid" icon={<IdcardOutlined />}>
                                        <Link to="/id-proofs-grid"><span>Id Proofs</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="languages" icon={<PicCenterOutlined />}>
                                        <Link to="/languages"><span>Languages</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/loan-categories-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/loan-categories-grid"><span>Loan Categories</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/over-time-categories-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/over-time-categories-grid"><span>Over Time Categories</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="/qualifications-view" icon={<PicCenterOutlined />}>
                                        <Link to="/qualifications-view"><span>Qualifications</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/relations-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/relations-grid"><span>Relations</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="roles-view" icon={<PicCenterOutlined />}>
                                        <Link to="/roles-view"><span>Roles</span></Link>
                                    </Menu.Item> */}

                                    {/* <Menu.Item key="/exit-action-view" icon={<PicCenterOutlined />}>
                                        <Link to="/exit-action-view"><span>Exit Action</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="recruitment-mode-view" icon={<PicCenterOutlined />}>
                                        <Link to="/recruitment-mode-view"><span>Recruitment-Mode</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="/skills-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/skills-grid"><span>Skills</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="/suggestion-view" icon={<PicCenterOutlined />}>
                                        <Link to="/suggestion-view"><span>Suggestions</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/pickup-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/pickup-grid"><span>Pickup</span></Link>
                                    </Menu.Item> */}



                                    {/* <Menu.Item key="/profiles-view" icon={<PicCenterOutlined />}>
                                        <Link to="/profiles-view"><span>Recruitment Profile</span> </Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/notifications-view" icon={<PicCenterOutlined />}>
                                        <Link to="/notifications-view"><span>Recruitment Notification</span> </Link>
                                    </Menu.Item> */}

                                    <Menu.Item key="/types-of-leaves-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/types-of-leaves-grid"><span>Types Of Leaves</span></Link>
                                    </Menu.Item>

                                    {/* <Menu.Item key="route-view" icon={<PicCenterOutlined />}>
                                        <Link to="/route-view"><span>Route</span></Link>
                                    </Menu.Item> */}

                                    {/* <Menu.Item key="/team-view" icon={<FontAwesomeIcon icon={faUserGroup} />}>
                                                <Link to="/team-view"><span>Shift Group</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="/shift-view" icon={<FontAwesomeIcon icon={faPeopleArrows} />}>
                                                <Link to="/shift-view"><span>Shift</span></Link>
                                            </Menu.Item> */}

                                    {/* <Menu.Item key="/certifications-view" icon={<PicCenterOutlined />}>
                                        <Link to="/certifications-view"><span>Certifications</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="/contractor-view" icon={<PicCenterOutlined />}>
                                        <Link to="/contractor-view"><span>Contractor</span></Link>
                                    </Menu.Item>


                                </SubMenu>

                            }
                           
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="Asset-view" icon={<AppstoreOutlined />}
                                    title={
                                        <span>
                                            <span>Assets</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="Asset-view" icon={<PicCenterOutlined />}>
                                        <Link to="/Asset-view"><span>Asset Activity Controller</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="Asset-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/Asset-grid"><span>Asset Activity </span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="asset-category" icon={<PicCenterOutlined />}>
                                        <Link to="/asset-category"><span>Asset Category</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="Asset-Location" icon={<EnvironmentOutlined />}>
                                        <Link to="/Asset-Location"><span>Asset Location</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="asset-checklist-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/asset-checklist-grid"><span>Check List</span></Link>
                                    </Menu.Item>

                                </SubMenu>


                            }
                             {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)) &&  
                             <>
                            {
                                <SubMenu
                                    key="finance" icon={<AccountBookOutlined />}
                                    title={
                                        <span>
                                            <span>Finance</span>
                                        </span>
                                    }
                                >

                                    <Menu.Item key="/rm-budget-view" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-budget-view"><span>RM Budget</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/sale-budget-view" icon={<PicCenterOutlined />}>
                                        <Link to="/sale-budget-view"><span>Sale Budget</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="expenses" icon={<PicCenterOutlined />}>
                                        <Link to="/Finance-expenses-view"><span>Expenses</span></Link>
                                    </Menu.Item> */}
                                </SubMenu>
                            }
                            </>  
                        }

                            {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="Finance" icon={<TransactionOutlined />}
                                    title={
                                        <span>
                                            <span>Finance</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="expenses" icon={<PicCenterOutlined />}>
                                        <Link to="/Finance-expenses-view"><span>Expenses</span></Link>
                                    </Menu.Item>

                                </SubMenu>


                            } */}

                        </SubMenu>

                    }
                     {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)) &&  
                             <>
                    {
                        <SubMenu
                            key="inquiry-management" icon={<MoneyCollectOutlined />}
                            title={
                                <span>
                                    <span>Enquiry Management</span>
                                </span>
                            }
                        >
                            {/* <Menu.Item key="inquiry-management-form" icon={<PicCenterOutlined />}>
                                <Link to="/inquiry-management-form"><span>inquiry Management</span></Link>
                        </Menu.Item> */}
                         {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)) &&  
                            <Menu.Item key="inquiry-management-view" icon={<PicCenterOutlined />}>
                                <Link to="/inquiry-management-view"><span>Enquiry Management</span></Link>
                            </Menu.Item>
                         }  
                          {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)) &&                      
                            <Menu.Item key="enquiry-assessment" icon={<PicCenterOutlined />}>
                                <Link to="/enquiry-assessment"><span>Enquiry Assessment</span></Link>
                            </Menu.Item> 
                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)) &&       
                            <Menu.Item key="freeze-unfreeze-info" icon={<PicCenterOutlined />}>
                                <Link to="/freeze-unfreeze-info"><span>Cost Sheet Generation</span></Link>
                            </Menu.Item>
                             }
                             {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)) &&       

                            <Menu.Item key="quotation-info-grid" icon={<PicCenterOutlined />}>
                                <Link to="/quotation-info-grid"><span>Quotation Info</span></Link>
                            </Menu.Item>
                              }
                            {/* <Menu.Item key="purchase-product-form" icon={<PicCenterOutlined />}>
                            <Link to="/purchase-product-form"><span>Product Purchase Form</span></Link>
                        </Menu.Item> */}
                            {/* <Menu.Item key="collections" icon={<PicCenterOutlined />}>
                            <Link to="/collections"><span>Collections</span></Link>
                        </Menu.Item> */}
                        </SubMenu>
                    }
                    </>
                     }

                    {/* {((JSON.parse(localStorage.getItem('role'))==='L4')||(JSON.parse(localStorage.getItem('role'))==='L1') ||(JSON.parse(localStorage.getItem('role'))==='L5'))  &&  */}
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                        <SubMenu
                            key="sales_module" icon={<MoneyCollectOutlined />}
                            title={
                                <span>
                                    <span>Sales</span>
                                </span>
                            }
                        >
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                                <>
                                    {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER)) &&
                                        <>
                                            <Menu.Item key="saleorder-form" icon={<PlusSquareOutlined />}>
                                                <Link to="/saleorder-form"><span>SO Creation</span></Link>
                                            </Menu.Item>
                                        </>} */}

                                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) ) &&
                                        <>
                                            <Menu.Item key="saleorder-tracker" icon={<MonitorOutlined />}>
                                                <Link to="/saleorder-tracker"><span>SO Tracker</span></Link>
                                            </Menu.Item>
                                        </>}

                                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&
                                        <>
                                            <Menu.Item key="subjob-revision" icon={<MonitorOutlined />}>
                                                <Link to="/subjob-revision"><span>Sub Job Revision</span></Link>
                                            </Menu.Item>
                                        </>}
                                
                                        {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                                        <>
                                
                                    <Menu.Item key="domestic-sales" icon={<PicCenterOutlined />}>
                                        <Link to="/domestic-sales"><span>Domestic Sales</span></Link>
                                    </Menu.Item>
                                    </>}
                                </>}

                        </SubMenu>
                    }

                    {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SR_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_SALES_MANAGER)) &&
                        <SubMenu
                            key="downtime-module" icon={<ScheduleOutlined  />}
                            title={
                                <span>
                                    <span>Downtime</span>
                                </span>
                            }
                        >
                            <Menu.Item key="DownTimeReason-view" icon={<PicCenterOutlined />}>
                                <Link to="/DownTimeReason-view"><span>Downtime Reason</span></Link>
                            </Menu.Item>
                            <Menu.Item key="downtimetracking-view" icon={<PicCenterOutlined />}>
                                <Link to="/downtimetracking-view"><span>DownTime Tracking</span></Link>
                            </Menu.Item>
                            <Menu.Item key="downtimetracking-view" icon={<PicCenterOutlined />}>
                                <Link to="/downtimetracking-view"><span>Downtime Tracking</span></Link>
                            </Menu.Item>
                            <Menu.Item key="downtime-event-calender" icon={<CalendarOutlined  />}>
                                <Link to="/downtime-event-calender"><span>Downtime Event Calender</span></Link>
                            </Menu.Item>
                        </SubMenu>
                    } */}

                    {/* {((JSON.parse(localStorage.getItem('role'))==='L4')||(JSON.parse(localStorage.getItem('role'))==='L2')) && */}
                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.UNIT_PACKING_CONTROLLER, EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER,EmployeeRolesEnum.WAREHOUSE_MANAGER, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                        <SubMenu
                            key="procurement_module" icon={<DropboxOutlined />}
                            title={
                                <span>
                                    <span>SCM</span>
                                </span>
                            }
                        >
                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.UNIT_PACKING_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&

                                <SubMenu
                                    key="procurement-procurement" icon={<DropboxOutlined />}
                                    title={
                                        <span>
                                            <span>PROCUREMENT</span>
                                        </span>
                                    }
                                >

                                    {
                                        (([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.UNIT_PACKING_CONTROLLER, EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="allsaleorders-view" icon={<MonitorOutlined />}>
                                                <Link to="/allsaleorders-view"><span>BOM Tracker</span></Link>
                                            </Menu.Item>
                                        </>
                                    }

                                    {
                                        (([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="packing-bom-report" icon={<FundProjectionScreenOutlined />}>
                                                <Link to="/packing-bom-report"><span>Packing BOM</span></Link>
                                            </Menu.Item>
                                        </>
                                    }

                                    {
                                        (([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="purchase-order-grid" icon={<FilePptOutlined />}>
                                                <Link to="/purchase-order-grid"><span>PO</span></Link>
                                            </Menu.Item>
                                        </>}

                                    {
                                        (([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="grn-form" icon={<ContainerOutlined />}>
                                                <Link to="/grn-grid"><span>GRN</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="grn-return-form" icon={<FileSyncOutlined />}>
                                                <Link to="/grn-return-grid"><span>GRN Return</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="tally-upload-files" icon={<FileSyncOutlined />}>
                                                <Link to="/tally-upload-files"><span>Tally Upload Files</span></Link>
                                            </Menu.Item>
                                        </>
                                    }

                                </SubMenu>}
                            {/* <Menu.Item key="packing-dashboard" icon={<FundProjectionScreenOutlined />}>
                                <Link to="/packing-dashboard"><span>Dashboard</span></Link>
                            </Menu.Item> */}
                            {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                            EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER,EmployeeRolesEnum.WAREHOUSE_MANAGER, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                <SubMenu
                                    key="inventory-procurement" icon={<DropboxOutlined />}
                                    title={
                                        <span>
                                            <span>INVENTORY</span>
                                        </span>
                                    }
                                >
                                    {
                                        (([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>

                                            {/* <Menu.Item key="rm-reserve-location" icon={<CarryOutOutlined />}>
                                                <Link to="/rm-reserve-location"><span>Reserve Locations</span></Link>
                                            </Menu.Item> */}
                                            {/* <Menu.Item key="location-mapping" icon={<FontAwesomeIcon icon={faLocationPin} />}>
                                        <Link to="/location-mapping"><span>Location Mapping</span></Link>
                                    </Menu.Item> */}
                                        </>
                                    }
                                    {
                                        (([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.PACKAGING_SUPERVISOR,EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="pending-grn-info-grid" icon={<CarryOutOutlined />}>
                                                <Link to="/pending-grn-info-grid"><span>Pending Location</span></Link>
                                            </Menu.Item>


                                            <Menu.Item key="grn-inspection-view" icon={<CarryOutOutlined />}>
                                                <Link to="/grn-inspection-view"><span>GRN Inspection</span></Link>
                                            </Menu.Item>

                                            {/* <Menu.Item key="grn-adjustment-note" icon={<FileSyncOutlined />}>
                                                <Link to="/grn-adjustment-note"><span>GRN Adjustment Note</span></Link>
                                        </Menu.Item> */}
                                            <Menu.Item key="adjustment-note-view" icon={<FileSyncOutlined />}>
                                                <Link to="/adjustment-note-view"><span>Debit/Credit Note </span></Link>
                                            </Menu.Item>
                                            {/* <Menu.Item key="location-mapping" icon={<FontAwesomeIcon icon={faLocationPin} />}>
                                        <Link to="/location-mapping"><span>Location Mapping</span></Link>
                                    </Menu.Item> */}
                                        </>
                                    }
                                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER,EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="stock-grid" icon={<GoldOutlined />}>
                                                <Link to="/stock-grid"><span>Stock</span></Link>
                                            </Menu.Item>
                                        </>
                                    }
                                    {/* {   (([EmployeeRolesEnum.ADMIN,EmployeeRolesEnum.PACKAGING_SUPERVISOR,EmployeeRolesEnum.PACKING_CAPTAINS,EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                 <>
                                      <Menu.Item key="packing-stock-entry" icon={<ImportOutlined />}>
                                            <Link to="/packing-stock-entry"><span>Stock Entry</span></Link>
                                        </Menu.Item>
                                 </>
                            } */}
                                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.PACKAGING_SUPERVISOR,EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="packing-product-conversion" icon={<InteractionFilled />}>
                                                <Link to="/packing-product-conversion"><span>Re-classification</span></Link>
                                            </Menu.Item>

                                            <Menu.Item key="cycle-checker" icon={<GroupOutlined />}>
                                                <Link to="/cycle-checker"><span>Cycle Checker</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="cycle-checker-approval" icon={<FontAwesomeIcon icon={faPersonCircleCheck} />}>
                                                <Link to="/cycle-checker-approval"><span>Cycle Checker Approval</span></Link>
                                            </Menu.Item>

                                            {/* <Menu.Item key="indent-grid-for-prepared-material" icon={<CarryOutOutlined />}>
                                        <Link to="/indent-grid-for-prepared-material"><span>Indent For Material Preperation</span></Link>
                                    </Menu.Item> */}

                                        </>
                                    }
                                    {
                                        ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)) && <>

                                            <Menu.Item key="stock-transfer-grid" icon={<ExportOutlined />}>
                                                <Link to="/stock-transfer-grid"><span>Stock Transfer</span></Link>
                                            </Menu.Item>
                                        </>}

                                </SubMenu>
                            }
                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.UNIT_PACKING_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) ) &&

                                <SubMenu
                                    key="packing-procurement" icon={<DropboxOutlined />}
                                    title={
                                        <span>
                                            <span>{GlobalVariableValues.productionVersion !== 'V2' ? 'PREPARATION' : 'INVENTORY DISPERSION'}</span>
                                        </span>
                                    }
                                >
                                    {(([EmployeeRolesEnum.ADMIN,EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.UNIT_PACKING_CONTROLLER, EmployeeRolesEnum.SUPER_ADMIN,EmployeeRolesEnum.WAREHOUSE_MANAGER].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="indent-grid-for-prepared-material" icon={<CarryOutOutlined />}>
                                                <Link to="/indent-grid-for-prepared-material"><span>Material Requisition</span></Link>
                                            </Menu.Item>

                                        </>
                                    }
                                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER,EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.UNIT_PACKING_CONTROLLER, EmployeeRolesEnum.SUPER_ADMIN,EmployeeRolesEnum.WAREHOUSE_MANAGER].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="material-reqisition-report" icon={<CarryOutOutlined />}>
                                                <Link to="/material-reqisition-report"><span>Material Requisition Report</span></Link>
                                            </Menu.Item>

                                        </>
                                    }
                                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER,EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.UNIT_PACKING_CONTROLLER, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.SUPER_ADMIN,EmployeeRolesEnum.WAREHOUSE_MANAGER].indexOf(role) > -1) &&
                                        GlobalVariableValues.productionVersion !== 'V2') && (
                                            <Menu.Item key="material-preperation-grid" icon={<ExportOutlined />}>
                                                <Link to="/material-preperation-grid"><span>Material Preparation</span></Link>
                                            </Menu.Item>
                                        )}

                                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER,EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.UNIT_PACKING_CONTROLLER, EmployeeRolesEnum.SUPER_ADMIN,EmployeeRolesEnum.WAREHOUSE_MANAGER].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            {/* <Menu.Item key="indent-module-form" icon={<FileSyncOutlined />}>
                                        <Link to="/indent-module-form"><span>Indent Form</span></Link>
                                    </Menu.Item>  */}
                                            {GlobalVariableValues.productionVersion !== 'V2' && (
                                                <Menu.Item key="indent-barcode-grid" icon={<FileSyncOutlined />}>
                                                    <Link to="/indent-barcode-grid"><span>Production Indent</span></Link>
                                                </Menu.Item>
                                            )}
                                            <Menu.Item key="store_return" icon={<FileSyncOutlined />}>
                                                <Link to="/store-return"><span>Material Return</span></Link>
                                            </Menu.Item>

                                            {/* <Menu.Item key="indent-form-for-prepared-material" icon={<CarryOutOutlined />}>
                                        <Link to="/indent-form-for-prepared-material"><span>Indent for Material</span></Link>
                                    </Menu.Item> */}

                                            {/* <Menu.Item key="pending-grn-info-grid" icon={<CarryOutOutlined />}>
                                        <Link to="/pending-grn-info-grid"><span>Grn Info Grid</span></Link>
                                    </Menu.Item> */}

                                            {/* <Menu.Item key="place-list-print" icon={<FileSyncOutlined />}>
                                        <Link to="/place-list-print"><span>Place List Print</span></Link>
                                    </Menu.Item> */}
                                        </>
                                    }
                                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER,EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.UNIT_PACKING_CONTROLLER,EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>
                                            <Menu.Item key="store-consumption-grid" icon={<ExportOutlined />}>
                                                <Link to="/store-consumption-grid"><span>Material Issues</span></Link>
                                            </Menu.Item>

                                        </>}

                                </SubMenu>}

                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SUPER_ADMIN)) &&
                                <SubMenu
                                    key="planning-procurement" icon={<FontAwesomeIcon icon={faBuildingCircleArrowRight} />}
                                    title={
                                        <span>
                                            <span>PLANNING</span>
                                        </span>
                                    }
                                >
                                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER, EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.SUPER_ADMIN].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                                        <>

                                            <Menu.Item key="etd-wise-grid" icon={<CarryOutOutlined />}>
                                                <Link to="/etd-wise-grid"><span>Plan Saleorders</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="/Planning-dashboard" icon={<CarryOutOutlined />}>
                                                <Link to="/Planning-dashboard"><span> Planning Dashboard</span></Link>
                                            </Menu.Item>

                                        </>
                                    }
                                </SubMenu>
                            }




                        </SubMenu>
                    }
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.OPERATIONS_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                        <SubMenu
                            key="rm_proc_module" icon={<ContainerOutlined />}
                            title={
                                <span>
                                    <span>RM Procurement</span>
                                </span>
                            }
                        >
                            {/* <Menu.Item key="rm-dashboard" icon={<ContainerOutlined />}>
                                <Link to="/rm-dashboard"><span>RM Dashboard</span></Link>
                            </Menu.Item> */}
                            {/* <Menu.Item key="procurement-dashboard" icon={<ContainerOutlined />}>
                                <Link to="/procurement-dashboard"><span>Procurement Dashboard</span></Link>
                            </Menu.Item> */}

                            <Menu.Item key="indent-view" icon={<ContainerOutlined />}>
                                <Link to="/indent-view"><span>Indent</span></Link>
                            </Menu.Item>
                            <Menu.Item key="vehicle-assignment" icon={<ContainerOutlined />}>
                                <Link to="/vehicle-assignment"><span>Assign Vehicle</span></Link>
                            </Menu.Item>
                            <Menu.Item key="rm-grn-grid" icon={<ContainerOutlined />}>
                                <Link to="/rm-grn-grid"><span>GRN</span></Link>
                            </Menu.Item>
                            <Menu.Item key="rm-invoice-form" icon={<ContainerOutlined />}>
                                <Link to="/rm-invoice-form"><span>Invoice</span></Link>
                            </Menu.Item>
                            {/* <Menu.Item key="reweighment-view" icon={<ContainerOutlined />}>
                                <Link to="/reweighment-view"><span>Reweighment View</span></Link>
                            </Menu.Item> */}

                            <Menu.Item key="reweighment-form" icon={<ContainerOutlined />}>
                                <Link to="/reweighment-form"><span>Reweighment</span></Link>
                            </Menu.Item>
                            <Menu.Item key="bom-tracker-grid" icon={<ContainerOutlined />}>
                                <Link to="/bom-tracker-grid"><span>Bom Tracker</span></Link>
                            </Menu.Item>
                            {/* <Menu.Item key="rm-indent-qty-limit-grid" icon={<ContainerOutlined />}>
                                <Link to="/rm-indent-qty-limit-grid"><span>Rm Indent Qty Limit</span></Link>
                            </Menu.Item> */}

                        </SubMenu>
                    }


                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.OPERATIONS_EXECUTIVE)) && GlobalVariableValues.productionVersion == 'V1' &&
                        <SubMenu
                            key="production" icon={<RiseOutlined />}
                            title={
                                <span>
                                    <span>Production</span>
                                </span>
                            }
                        >
                            <Menu.Item key="production-inventory-grid" icon={<ContainerOutlined />}>
                                <Link to="/production-inventory-grid"><span>Received Lots Info</span></Link>
                            </Menu.Item>
                            <Menu.Item
                                key="product-convertion-grid"
                                icon={<ContainerOutlined />}
                            >
                                <Link to="/product-convertion-grid">
                                    <span>Product Conversion</span>
                                </Link>
                            </Menu.Item>
                            <Menu.Item
                                key="lot-clubbing"
                                icon={<ContainerOutlined />}
                            >
                                <Link to="/lot-clubbing">
                                    <span>Lot Clubbing</span>
                                </Link>
                            </Menu.Item>


                            <SubMenu
                                key="sub-plant-operations" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Stock Transfer</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="inventory-stock-transfer-grid" icon={<ContainerOutlined />}>
                                    <Link to="/inventory-stock-transfer-grid"><span>Send</span></Link>
                                </Menu.Item>
                                <Menu.Item key="sub-plant-operations-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/sub-plant-operations-grid"><span>Operations</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="sub-plant-val-addition-report" icon={<PicCenterOutlined />}>
                                    <Link to="/sub-plant-val-addition-report"><span>Sub Plant Val Addition Report</span></Link>
                                </Menu.Item>

                                <Menu.Item key="report-subplant-operations" icon={<PicCenterOutlined />}>
                                    <Link to="/report-subplant-operations"><span>Reporting</span></Link>
                                </Menu.Item> */}
                                {/* <Menu.Item key="receive-subplant-stock" icon={<PicCenterOutlined />}>
                                    <Link to="/receive-subplant-stock"><span>Beheading to Deheading</span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="receive-subplant-stock" icon={<PicCenterOutlined />}>
                                    <Link to="/receive-subplant-stock"><span>Receive</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="send-receive-transactions" icon={<PicCenterOutlined />}>
                                    <Link to="/send-receive-transactions"><span>Send And Receive Transactions</span></Link>
                                </Menu.Item> */}

                            </SubMenu>
                            <SubMenu
                                key="beheading" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Deheading</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="grn-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/grn-inventory"><span>Grn Inventory</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="be-heading-dashboard" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-dashboard"><span>Deheading Dashboard</span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="be-heading-inprogress-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-inprogress-inventory"><span>Deheading Work In-Progress</span></Link>
                                </Menu.Item>
                                <Menu.Item key="be-heading-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-inventory"><span>Deheading Inventory</span></Link>
                                </Menu.Item>

                                {/* <Menu.Item key="be-heading-sub-plant-history" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-sub-plant-history"><span>Sub Plant Operations</span></Link>
                                </Menu.Item> */}
                                {/* <Menu.Item key="be-heading" icon={<ContainerOutlined />}>
                                <Link to="/be-heading"><span>Assign Rm Inventory To Beheading</span></Link>
                            </Menu.Item> */}
                            </SubMenu>

                            <SubMenu
                                key="grading" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Grading</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="deheading-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/deheading-inventory"><span>Deheading Inventory</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="grade-dashboard" icon={<ContainerOutlined />}>
                                    <Link to="/grade-dashboard"><span>Grading Dashboard</span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="assign-to-grading" icon={<ContainerOutlined />}>
                                    <Link to="/assign-to-grading"><span>Assign to Grading</span></Link>
                                </Menu.Item>
                                <Menu.Item key="grade-reporting" icon={<ContainerOutlined />}>
                                    <Link to="/grade-reporting"><span>Grade Reporting</span></Link>
                                </Menu.Item>
                                <Menu.Item key="assign-so-to-grade" icon={<ContainerOutlined />}>
                                    <Link to="/assign-so-to-grade"><span>Assign SO to Grade</span></Link>
                                </Menu.Item>
                                <Menu.Item key="grade-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/grade-inventory"><span>Grading Inventory</span></Link>
                                </Menu.Item>
                                <Menu.Item key="yield-report" icon={<ContainerOutlined />}>
                                    <Link to="/yield-report"><span>Yield Report</span></Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu
                                key="valAddition" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Value addition</span>
                                    </span>
                                }
                            >
                                {/* <Menu.Item key="assign-to-val-addition" icon={<PicCenterOutlined />}>
                                <Link to="/assign-to-val-addition"><span>Val Addition dashboard</span></Link>
                            </Menu.Item> */}
                                {/* <Menu.Item key="val-addition-grading-dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/val-addition-grading-dashboard"><span>Value Addition Dashboard</span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="val-addition-inventory-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/val-addition-inventory-grid"><span>Value Addition Inventory</span></Link>
                                </Menu.Item>


                            </SubMenu>

                            {/* <Menu.Item key="soaking" icon={<ExperimentTwoTone />}>
                            <Link to="/soaking"><span>Soaking</span></Link>
                        </Menu.Item> */}
                            {/* </Menu.Item> */}

                            {(JSON.parse(localStorage.getItem('plantType')) === UnitTypeEnum.PLANT) &&
                                <SubMenu
                                    key="soaking" icon={<ExperimentTwoTone />}
                                    title={
                                        <span>
                                            <span>Soaking</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="val-addition-soaking-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/val-addition-soaking-grid"><span>Ready For Soaking Inventory</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="soaking-dashboard" icon={<ContainerOutlined />}>
                                        <Link to="/soaking-dashboard"><span>Soaking Dashboard</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="soaking-assignment-grid" icon={<ContainerOutlined />}>
                                        <Link to="/soaking-assignment-grid"><span>Soaking Inventory</span></Link>
                                    </Menu.Item>

                                    {/* <Menu.Item key="soaking-tub" icon={<ContainerOutlined />}>
                                <Link to="/soaking-tub"><span>Soaking Tub</span></Link>

                            </Menu.Item> */}
                                    {/* <Menu.Item key="soaking-main-dashboard" icon={<ContainerOutlined />}>
                                        <Link to="/soaking--main-dashboard"><span>Soaking Tub Dashboard</span></Link>
                                    </Menu.Item> */}

                                    <Menu.Item key="soaking-tub-report" icon={<ContainerOutlined />}>
                                        <Link to="/soaking-tub-report"><span>Soaking Tub Report</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                            <Link to="/assign-soaking-for-freezing"><span>Assign Soaking for Freezing</span></Link>
                            </Menu.Item> */}
                                    {/* <Menu.Item key="soaking-reporting" icon={<ContainerOutlined />}>
                                <Link to="/soaking-reporting"><span>Soaking Reporting</span></Link>
                            </Menu.Item> */}

                                </SubMenu>
                            }

                            {(JSON.parse(localStorage.getItem('plantType')) === UnitTypeEnum.PLANT) && <Menu.Item key="cooking-grid" icon={<ContainerOutlined />}>
                                <Link to="/cooking-grid"><span>Cooking</span></Link>
                            </Menu.Item>
                            }
                            {(JSON.parse(localStorage.getItem('plantType')) === UnitTypeEnum.PLANT) &&

                                <SubMenu
                                    key="freezing" icon={<ExperimentTwoTone />}
                                    title={
                                        <span>
                                            <span>Freezing</span>
                                        </span>
                                    }
                                >

                                    <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                                        <Link to="/assign-soaking-for-freezing"><span>Assigning for Freezing</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                            <Link to="/assign-for-freezing-form"><span>Assign Soaking for Freezing</span></Link>
                        </Menu.Item> */}
                                </SubMenu>}
                            <SubMenu
                                key="rejections" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Rejections</span>
                                    </span>
                                }
                            >


                                <Menu.Item key="rejections-grid" icon={<ContainerOutlined />}>
                                    <Link to="/rejections-grid"><span>Rejections Inventory</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                            <Link to="/assign-for-freezing-form"><span>Assign Soaking for Freezing</span></Link>
                        </Menu.Item> */}
                            </SubMenu>
                        </SubMenu>
                    }

                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.OPERATIONS_EXECUTIVE) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) && GlobalVariableValues.productionVersion == 'V2' &&
                        <SubMenu
                            key="production" icon={<RiseOutlined />}
                            title={
                                <span>
                                    <span>Production</span>
                                </span>
                            }
                        >
                            <Menu.Item key="production-inventory-grid" icon={<ContainerOutlined />}>
                                <Link to="/production-inventory-grid"><span>Received Lots Info</span></Link>
                            </Menu.Item>

                            <SubMenu
                                key="reportings" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Reportings</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="production-operations" icon={<ContainerOutlined />}>
                                <Link to="/production-operations"><span>Operation Reportings</span></Link>
                                </Menu.Item>

                                <Menu.Item key="grade-reporting" icon={<ContainerOutlined />}>
                                    <Link to="/grade-reporting"><span>Grade Reporting</span></Link>
                                </Menu.Item>
                                
                                <Menu.Item key="jobs-reporting-info" icon={<ContainerOutlined />}>
                                    <Link to="/jobs-reporting-info"><span>ReportingInfo</span></Link>
                                </Menu.Item>
                                <Menu.Item key="non-soaking-reporting-info" icon={<ContainerOutlined />}>
                                    <Link to="/non-soaking-reporting-info"><span>Non-Soaking Reportings Info</span></Link>
                                </Menu.Item>
                                <Menu.Item key="deheading-bill-info" icon={<ContainerOutlined />}>
                                    <Link to="/contractor-bill-info"><span>Contractor Wise Bill info</span></Link>
                                </Menu.Item>
                                <Menu.Item key="deheading-contractor-wise-bill-generation" icon={<ContainerOutlined />}>
                                    <Link to="/deheading-contractor-wise-bill-generation"><span>Contractor Wise Bill Generation</span></Link>
                                </Menu.Item>
                                
                            </SubMenu>

                            {/* <Menu.Item key="production-operations" icon={<ContainerOutlined />}>
                                <Link to="/production-operations"><span>Production Operations</span></Link>
                            </Menu.Item> */}
                            <SubMenu
                                key="inventory" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Inventory</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="grn-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/grn-inventory"><span>Grn Inventory</span></Link>
                                </Menu.Item>

                                <Menu.Item key="be-heading-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-inventory"><span>Deheading Inventory</span></Link>
                                </Menu.Item>

                                <Menu.Item key="grade-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/grade-inventory"><span>Grading Inventory</span></Link>
                                </Menu.Item>

                                <Menu.Item key="val-addition-soaking-grid" icon={<PicCenterOutlined />}>
                                     <Link to="/val-addition-soaking-grid"><span>Value Addition Inventory</span></Link>
                                </Menu.Item>

                                <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                                <Link to="/assign-soaking-for-freezing"><span>Soaking Inventory</span></Link>
                                </Menu.Item>
 

                            </SubMenu>
                            
                            <SubMenu
                                key="sub-plant-operations" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Stock Transfer</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="inventory-stock-transfer-grid" icon={<ContainerOutlined />}>
                                    <Link to="/inventory-stock-transfer-grid"><span>Send</span></Link>
                                </Menu.Item>
                                <Menu.Item key="sub-plant-operations-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/sub-plant-operations-grid"><span>Operations</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="sub-plant-val-addition-report" icon={<PicCenterOutlined />}>
                                    <Link to="/sub-plant-val-addition-report"><span>Sub Plant Val Addition Report</span></Link>
                                </Menu.Item>

                                <Menu.Item key="report-subplant-operations" icon={<PicCenterOutlined />}>
                                    <Link to="/report-subplant-operations"><span>Reporting</span></Link>
                                </Menu.Item> */}
                                {/* <Menu.Item key="receive-subplant-stock" icon={<PicCenterOutlined />}>
                                    <Link to="/receive-subplant-stock"><span>Beheading to Deheading</span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="receive-subplant-stock" icon={<PicCenterOutlined />}>
                                    <Link to="/receive-subplant-stock"><span>Receive</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="send-receive-transactions" icon={<PicCenterOutlined />}>
                                    <Link to="/send-receive-transactions"><span>Send And Receive Transactions</span></Link>
                                </Menu.Item> */}

                            </SubMenu>
                                <Menu.Item
                                    key="lot-clubbing"
                                    icon={<ContainerOutlined />}
                                >
                                    <Link to="/lot-clubbing">
                                        <span>Lot Clubbing</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="loading-sheet" icon={<FontAwesomeIcon icon={faFileInvoice} />}>
                                    <Link to="/loading-sheet"><span>Loading Sheet</span></Link>
                                </Menu.Item>

                            {/* <SubMenu
                                key="beheading" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Deheading</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="grn-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/grn-inventory"><span>Grn Inventory</span></Link>
                                </Menu.Item>
                                <Menu.Item key="be-heading-dashboard" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-dashboard"><span>Deheading Dashboard</span></Link>
                                </Menu.Item>
                                <Menu.Item key="be-heading-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-inventory"><span>Deheading Inventory</span></Link>
                                </Menu.Item>

                                <Menu.Item key="be-heading-sub-plant-history" icon={<ContainerOutlined />}>
                                    <Link to="/be-heading-sub-plant-history"><span>Sub Plant Operations</span></Link>
                                </Menu.Item>
                                <Menu.Item key="be-heading" icon={<ContainerOutlined />}>
                                <Link to="/be-heading"><span>Assign Rm Inventory To Beheading</span></Link>
                            </Menu.Item>
                            </SubMenu> */}

                            {/* <SubMenu
                                key="grading" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Grading</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="grade-dashboard" icon={<ContainerOutlined />}>
                                    <Link to="/grade-dashboard"><span>Grading Dashboard</span></Link>
                                </Menu.Item>
                                <Menu.Item key="grade-reporting" icon={<ContainerOutlined />}>
                                    <Link to="/grade-reporting"><span>Grade Reporting</span></Link>
                                </Menu.Item>
                                <Menu.Item key="grade-inventory" icon={<ContainerOutlined />}>
                                    <Link to="/grade-inventory"><span>Grading Inventory</span></Link>
                                </Menu.Item>
                            </SubMenu> */}
                            {/* <SubMenu
                                key="valAddition" icon={<ContainerOutlined />}
                                title={
                                    <span>
                                        <span>Value addition</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="assign-to-val-addition" icon={<PicCenterOutlined />}>
                                <Link to="/assign-to-val-addition"><span>Val Addition dashboard</span></Link>
                            </Menu.Item>
                                <Menu.Item key="val-addition-grading-dashboard" icon={<PicCenterOutlined />}>
                                    <Link to="/val-addition-grading-dashboard"><span>Value Addition Dashboard</span></Link>
                                </Menu.Item>
                                <Menu.Item key="val-addition-inventory-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/val-addition-inventory-grid"><span>Value Addition Inventory</span></Link>
                                </Menu.Item>


                            </SubMenu> */}

                            {/* <Menu.Item key="soaking" icon={<ExperimentTwoTone />}>
                            <Link to="/soaking"><span>Soaking</span></Link>
                        </Menu.Item> */}
                            {/* </Menu.Item> */}

                            {/* {(JSON.parse(localStorage.getItem('plantType')) === UnitTypeEnum.PLANT) &&
                                <SubMenu
                                    key="soaking" icon={<ExperimentTwoTone />}
                                    title={
                                        <span>
                                            <span>Soaking</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="val-addition-soaking-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/val-addition-soaking-grid"><span>Ready For Soaking Inventory</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="val-addition-soaking-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/val-addition-soaking-grid"><span>Value Addition Inventory</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="soaking-dashboard" icon={<ContainerOutlined />}>
                                        <Link to="/soaking-dashboard"><span>Soaking Dashboard</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="soaking-assignment-grid" icon={<ContainerOutlined />}>
                                        <Link to="/soaking-assignment-grid"><span>Soaking Inventory</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="soaking-tub" icon={<ContainerOutlined />}>
                                <Link to="/soaking-tub"><span>Soaking Tub</span></Link>

                            </Menu.Item>
                                    <Menu.Item key="soaking-main-dashboard" icon={<ContainerOutlined />}>
                                        <Link to="/soaking--main-dashboard"><span>Soaking Tub Dashboard</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="soaking-tub-report" icon={<ContainerOutlined />}>
                                        <Link to="/soaking-tub-report"><span>Soaking Tub Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                            <Link to="/assign-soaking-for-freezing"><span>Assign Soaking for Freezing</span></Link>
                            </Menu.Item>
                                    <Menu.Item key="soaking-reporting" icon={<ContainerOutlined />}>
                                <Link to="/soaking-reporting"><span>Soaking Reporting</span></Link>
                            </Menu.Item>
                             <Menu.Item key="assign-soaking-for-freezin" icon={<ContainerOutlined />}>
                            <Link to="/assign-soaking-for-freezing"><span>Soaking Inventory</span></Link>
                            </Menu.Item>

                                </SubMenu>
                            } */}

                        </SubMenu>
                    }

                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.UNIT_PACKING_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON)) &&
                        <SubMenu
                            key="qa-qc" icon={<RiseOutlined />}
                            title={
                                <span>
                                    <span>QA/QC</span>
                                </span>
                            }
                        >
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON)) &&
                                <>
                                  <Menu.Item key="antibiotics-view" icon={<ContainerOutlined />}>
                                        <Link to="/antibiotics-view"><span>Antibiotics</span></Link>
                                    </Menu.Item>

                                    {/* <Menu.Item key="qa-qc-sample-test-grid" icon={<ContainerOutlined />}>
                                        <Link to="/qa-qc-sample-test-grid"><span>Rejections</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="labelling-grid" icon={<ContainerOutlined />}>
                                        <Link to="labelling-grid"><span>Labelling</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/fg-inspection-print" icon={<ContainerOutlined />}>
                                        <Link to="/fg-inspection-print"><span>Fg-inspection </span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/inspection-print" icon={<PicCenterOutlined />}>
                                        <Link to="/inspection-print"><span >Product-inspection </span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/pd-qaqc-print" icon={<PicCenterOutlined />}>
                                        <Link to="/pd-qaqc-print"><span >PD </span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/metal-detection-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/metal-detection-grid"><span >Metal Detection</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="so-inspection" icon={<PicCenterOutlined />}>
                                        <Link to="/so-inspection"><span>SO Inspection</span></Link>
                                    </Menu.Item> */}
                                </>}


                            {/* <Menu.Item key="qcdefect-form" icon={<PicCenterOutlined />}>
                                <Link to="/qcdefect-form"><span>Qc Defect Tracking</span></Link>
                            </Menu.Item> */}
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.UNIT_PACKING_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.QAQC_PERSON)) && <>
                                <Menu.Item key="code-list-main-grid" icon={<ScheduleOutlined />}>
                                    <Link to="/code-list-main-grid"><span>Code List Allocation</span></Link>
                                </Menu.Item>
                            </>}

                            <Menu.Item key="Qc-Clearance" icon={<ContainerOutlined />}>
                                        <Link to="/qc-clearance"><span>QC Clearance</span></Link>
                                    </Menu.Item>

                        </SubMenu>
                    }


                    {(([EmployeeRolesEnum.ADMIN, EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER, EmployeeRolesEnum.WAREHOUSE_MANAGER, EmployeeRolesEnum.WAREHOUSE_INCHARGE,].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) &&
                        <SubMenu
                            key="warehouseManagement" icon={<FontAwesomeIcon icon={faWarehouse} />}
                            title={
                                <span>
                                    <span>Warehouse</span>
                                </span>
                            }
                        >
                            {/* <Menu.Item key="reporting" icon={<DownloadOutlined />}>
                                <Link to="/reporting"><span>Stock In</span></Link>
                            </Menu.Item> */}
                            <Menu.Item key="wh-dashboard" icon={<PicCenterOutlined />}>
                                <Link to="/wh-dashboard"><span>Warehouse</span></Link>
                            </Menu.Item>
                            <Menu.Item key="reporting" icon={<FontAwesomeIcon icon={faArrowRightToBracket} />}>
                                <Link to="/stock-in"><span>Stock In</span></Link>
                            </Menu.Item>
                            {/* <Menu.Item key="stock-placement" icon={<FontAwesomeIcon icon={faArrowRightToBracket} />}>
                                <Link to="/stock-placement"><span>Stock Placement</span></Link>
                            </Menu.Item> */}
                            <Menu.Item key="fgstock" icon={<FontAwesomeIcon icon={faBoxesStacked} />}>
                                <Link to="/fg-stock"><span>Stock</span></Link>
                            </Menu.Item>
                            {/* <Menu.Item key="generate-pick-list" icon={<FontAwesomeIcon icon={faArrowRightFromBracket} />}>
                                <Link to="/generate-pick-list"><span>Generate Pick List</span></Link>
                            </Menu.Item> */}
                            {/* <Menu.Item key="reporting" icon={<FontAwesomeIcon icon={faArrowRightToBracket} />}>
                                <Link to="/swap-in"><span>Stock In</span></Link>
                            </Menu.Item> */}

                            {/* <Menu.Item key="stock-out-verification" icon={<FontAwesomeIcon icon={faArrowRightToBracket} />}>
                                <Link to="/stock-out-verification"><span>Stock out Verification</span></Link>
                            </Menu.Item> */}

                            {/* Mar 17 reserve & Suggestion is in hold,so this screen access commented */}
                            {/* did this screen to update location when they want to overide with unreserved location  */}
                            {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_INCHARGE)) &&
                                <Menu.Item key="location-update" icon={<FontAwesomeIcon icon={faBoxesStacked} />}>
                                    <Link to="/location-update"><span>Location Update</span></Link>
                                </Menu.Item>
                            } */}
                            <Menu.Item key="stock-out-grid" icon={<FontAwesomeIcon icon={faArrowRightFromBracket} />}>
                                <Link to="/stock-out-grid"><span>Stock Out</span></Link>
                            </Menu.Item>
                            <Menu.Item key="stock-in-reverse" icon={<FontAwesomeIcon icon={faArrowsRotate} />}>
                                <Link to="/stock-in-reverse"><span>Stock In Reverse</span></Link>
                            </Menu.Item>


                            <Menu.Item key="reserve-racks" icon={<InsertRowLeftOutlined />}>
                                <Link to="/reserve-racks"><span>Reserve Racks</span></Link>
                            </Menu.Item>
                            <Menu.Item key="reprocess-repacking" icon={<FontAwesomeIcon icon={faBoxOpen} />}>
                                <Link to="/reprocess-repacking"><span>Repacking & Reprocessing Report</span></Link>
                            </Menu.Item>
                            <Menu.Item key="fg-stock-transfer" icon={<FontAwesomeIcon icon={faCartFlatbedSuitcase} />}>
                                <Link to="/fg-stock-transfer"><span>Fg Stock transfer</span></Link>
                            </Menu.Item>
                            <Menu.Item key="temperature-log-view" icon={<FontAwesomeIcon icon={faTemperatureHalf} />}>
                                <Link to="/temperature-log-view"><span>Temperature Log</span></Link>
                            </Menu.Item>
                            <Menu.Item key="container-log-book-grid" icon={<FontAwesomeIcon icon={faBook} />}>
                                <Link to="/container-log-book-grid"><span>Container Log Book</span></Link>
                            </Menu.Item>
                            <Menu.Item key="fg-damages-view" icon={<FontAwesomeIcon icon={faBook} />}>
                                <Link to="/fg-damages-view"><span>Realtime Damages of warehouse</span></Link>
                            </Menu.Item>



                            {/* <Menu.Item key="dispatch-list-grid" icon={<DownloadOutlined />}>
                                <Link to="/dispatch-list-grid"><span>Dispatch List</span></Link>
                            </Menu.Item> */}
                        </SubMenu>
                    }
                    {/* } */}
                    {/* {((JSON.parse(localStorage.getItem('role'))==='L4')||(JSON.parse(localStorage.getItem('role'))==='L3')) && */}
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON) ) &&
                        <SubMenu
                            key="logistics" icon={<FontAwesomeIcon icon={faTruckFast} />}
                            title={
                                <span>
                                    <span>Logistics</span>
                                </span>
                            }
                        >
                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&

                                <Menu.Item key="container-register-grid" icon={<FontAwesomeIcon icon={faTruckLoading} />} >
                                    <Link to="/container-register-grid"><span>Container Register</span></Link>
                                </Menu.Item>
                            }

                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&

                                <Menu.Item key="bl-status-grid" icon={<BookOutlined />}>
                                    <Link to="/bl-status-grid"><span>Post Shipment</span></Link>
                                </Menu.Item>
                            }
                            {/* 
`{
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&

                                <Menu.Item key="post-shipment-form" icon={<BookOutlined />}>
                                    <Link to="/post-shipment-form"><span>Post Shipment</span></Link>
                                </Menu.Item>
                            }` */}
                            {/* {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&

                                <Menu.Item key="expenses-logistics-view" icon={<BookOutlined />}>
                                    <Link to="/expenses-logistics-view"><span>Expenses</span></Link>
                                </Menu.Item>
                            } */}

                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON)) &&
                                <Menu.Item key="invoice-grid" icon={<FontAwesomeIcon icon={faFileInvoice} />}>
                                    <Link to="/invoice-grid"><span>Invoice</span></Link>
                                </Menu.Item>
                            }


                            {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&
                                <Menu.Item key="loading-sheet" icon={<FontAwesomeIcon icon={faFileInvoice} />}>
                                    <Link to="/loading-sheet"><span>Loading Sheet</span></Link>
                                </Menu.Item>
                            } */}


                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&
                                <><Menu.Item key="document-register" icon={<FontAwesomeIcon icon={faFileLines} />}>
                                    <Link to="/document-register"><span>Document Register</span></Link>
                                </Menu.Item>
                                    {/* <Menu.Item key="rm-material-reweighment" icon={<FontAwesomeIcon icon={faFileLines} />}>
                                        <Link to="/rm-material-reweighment"><span>RM Reweighment</span></Link>
                                    </Menu.Item> */}
                                </>
                            }
                            {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER)) &&
                                <Menu.Item key="rm-grn-print" icon={<FontAwesomeIcon icon={faFileLines} />}>
                                    <Link to="/rm-grn-print"><span>RM GRN Print</span></Link>
                                </Menu.Item>
                            } */}


                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.DOCUMENTATION_EXECUTIVE) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_PLANT_HEAD) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.LOGISTICS_AND_WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&
                                <Menu.Item key="document-approval" icon={<FontAwesomeIcon icon={faFileCircleCheck} />}>
                                    <Link to="/document-approval"><span>Documents Approval</span></Link>
                                </Menu.Item>
                            }

                            {/* <Menu.Item key="log-book" icon={<FontAwesomeIcon icon={faBook} />}>
                                <Link to="/log-book"><span>Log Book</span></Link>
                            </Menu.Item> */}
                        </SubMenu>
                    }

                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="hrms" icon={<TeamOutlined />}
                            title={
                                <span>
                                    <span>HRMS</span>
                                </span>
                            }
                        >
                            <SubMenu key=" recruitment" icon={<UserAddOutlined />}
                                title={
                                    <span>
                                        <span> Recruitment</span>
                                    </span>
                                }>
                                <Menu.Item key="/notifications-view" icon={<PicCenterOutlined />}>
                                    <Link to="/notifications-view"><span>Recruitment Notification</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/profiles-view" icon={<PicCenterOutlined />}>
                                    <Link to="/profiles-view"><span>Recruitment Profile</span> </Link>
                                </Menu.Item>

                                <Menu.Item key="/interview-view" icon={<PicCenterOutlined />}>
                                    <Link to="/interview-view"><span>Interview</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/activities-view" icon={<PicCenterOutlined />}>
                                    <Link to="/activities-view"><span>Recruitment Activities</span> </Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu key="Employee Management" icon={<UserOutlined />}
                                title={
                                    <span>
                                        <span>Employee Management</span>
                                    </span>
                                }>
                                {/* <Menu.Item key="employee-detail-view" icon={<PicCenterOutlined />}>
                                    <Link to="/employee-detail-view"><span>Employee Detail view</span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="HRMS-employee_details-view" icon={<PicCenterOutlined />}>
                                    <Link to="/HRMS-employee_details-view"><span>Employees</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="/create-attn-logs" icon={<PicCenterOutlined />}>
                                    <Link to="/create-attn-logs"><span>Create Employee Attendance Logs</span></Link>
                                </Menu.Item> */}
                                {/* <Menu.Item key="/teamcalender-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/teamcalender-grid"><span>Team Calendar</span></Link>
                                </Menu.Item> */}
                                {/* <Menu.Item key="/employee-shift-mapping" icon={<PicCenterOutlined />}>
                                    <Link to="/employee-shift-mapping"><span>Employee Shift Mapping</span></Link>
                                </Menu.Item> */}

                                <Menu.Item key="/employee-week-off-view" icon={<PicCenterOutlined />}>
                                    <Link to="/employee-week-off-view"><span>Employee Week-Off Uploads</span></Link>
                                </Menu.Item>
                                {/* <Menu.Item key="/workcalender-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/workcalender-grid"><span>Work Calender</span></Link>
                                </Menu.Item> */}

                            </SubMenu>
                            <SubMenu key="Attendance Management" icon={<UserOutlined />}
                                title={
                                    <span>
                                        <span>Attendance Management</span>
                                    </span>
                                }>
                                {/* <Menu.Item key="miscellaneous-logs" icon={<PicCenterOutlined />}>
                                    <Link to="/miscellaneous-logs"><span>Criteria not Matching Logs</span></Link>
                                </Menu.Item> */}
                                <Menu.Item key="attendance-adjustment" icon={<PicCenterOutlined />}>
                                    <Link to="/attendance-main"><span>Attendance Adjustment</span></Link>
                                </Menu.Item>
                                <Menu.Item key="attendance-adjustment-approval" icon={<PicCenterOutlined />}>
                                    <Link to="/attendance-adjustment-approval"><span>Attendance Adjustment Approval</span></Link>
                                </Menu.Item>
                            </SubMenu>
                            {/* <Menu.Item key="HRMS-uplode-deatails" icon={<PicCenterOutlined />}>
                                <Link to="/HRMS-uplode-deatails"><span>HRMS-Upload-Details</span></Link>
                            </Menu.Item> */}

                            <SubMenu key="leave-management" icon={<UserDeleteOutlined />}
                                title={
                                    <span>
                                        <span>Leave Management</span>
                                    </span>
                                }>
                                <Menu.Item key="/employee-leaves-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/employee-leaves-grid"><span>Employee Leaves</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/apply-for-leaves" icon={<PicCenterOutlined />}>
                                    <Link to="/apply-for-leaves"><span>Apply for Leaves</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/apply-for-od-co-grid" icon={<PicCenterOutlined />}>
                                    <Link to="/apply-for-od-co-grid"><span>Apply for CO-OD</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/leave-approval" icon={<PicCenterOutlined />}>
                                    <Link to="/leave-approval"><span>Leave Approval</span></Link>
                                </Menu.Item>
                                <Menu.Item key="/holiday-calander" icon={<CalendarOutlined />}>
                                    <Link to="/holiday-calander"><span>Holiday Calander</span></Link>
                                </Menu.Item>
                            </SubMenu>

                            <SubMenu key="employee-actions" icon={<UserSwitchOutlined />}
                                title={
                                    <span>
                                        <span>Employee Actions</span>
                                    </span>
                                }>

                                <Menu.Item key="designationaction-view" icon={<PicCenterOutlined />}>
                                    <Link to="/designationaction-view"><span>Designation Action</span></Link>
                                </Menu.Item>

                                <Menu.Item key="/exit-action-view" icon={<PicCenterOutlined />}>
                                    <Link to="/exit-action-view"><span>Exit Action</span></Link>
                                </Menu.Item>

                                <Menu.Item key="transfer-action-view" icon={<PicCenterOutlined />}>
                                    <Link to="/transfer-action-view"><span>Trasfer Action</span></Link>
                                </Menu.Item>
                            </SubMenu>
                            {/* <Menu.Item key="/expenses-view" icon={<PicCenterOutlined />}>
                                <Link to="/expenses-view"><span>Expenses </span></Link>
                            </Menu.Item>
                            <Menu.Item key="/suggestion-view" icon={<PicCenterOutlined />}>
                                <Link to="/suggestion-view"><span>Suggestions</span></Link>
                            </Menu.Item>
                            <Menu.Item key="/self-service-portal" icon={<PicCenterOutlined />}>
                                <Link to="/self-service-portal"><span>Self-service-portal</span></Link>
                            </Menu.Item> */}
                            {/* <Menu.Item key="/ot-apply" icon={<PicCenterOutlined />}>
                                <Link to="/ot-apply"><span>OT Apply</span></Link>
                            </Menu.Item>
                            <Menu.Item key="/ot-approval" icon={<PicCenterOutlined />}>
                                <Link to="/ot-approval"><span>OT Approval</span></Link>
                            </Menu.Item> */}
                        </SubMenu>
                    }
                     {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="payroll" icon={<FontAwesomeIcon icon={faMoneyCheckDollar} /> }
                            title={
                                <span>
                                    <span>Payroll</span>
                                </span>
                            }
                        >
                            <SubMenu key="generaton-entries" icon={<FontAwesomeIcon icon={faPenToSquare} /> }
                                title={
                                    <span>
                                        <span> PayRoll Entrees</span>
                                    </span>
                                }>
                                
                                <Menu.Item key="/payroll-process" icon={<PicCenterOutlined />}>
                                    <Link to="/payroll-process"><span>Employee Payables</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/deductions-view" icon={<PicCenterOutlined />}>
                                    <Link to="/deductions-view"><span>Other Deductions Uploads</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/earnings-view" icon={<PicCenterOutlined />}>
                                    <Link to="/earnings-view"><span>Other Earnings Uploads</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/tds-view" icon={<PicCenterOutlined />}>
                                    <Link to="/tds-view"><span>TDS Uploads</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/employee-payroll-component" icon={<PicCenterOutlined />}>
                                    <Link to="/employee-payroll-component"><span>Payroll Components</span> </Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu key="generaton" icon={<FontAwesomeIcon icon={faComputer} /> }
                                title={
                                    <span>
                                        <span> PayRoll Generation</span>
                                    </span>
                                }>
                                <Menu.Item key="/payroll-generation" icon={<PicCenterOutlined />}>
                                    <Link to="/payroll-generation"><span>Generate</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/generation-view" icon={<PicCenterOutlined />}>
                                    <Link to="/generation-view"><span>Generated View</span> </Link>
                                </Menu.Item>
                                <Menu.Item key="/payslip-genaration" icon={<PicCenterOutlined />}>
                                    <Link to="/payslip-genaration"><span>Payslip Generation</span> </Link>
                                </Menu.Item>
                                
                                
                            </SubMenu>
                           
                        </SubMenu>
                    }
                    {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu key="visitor-management" icon={<UserOutlined />}
                            title={
                                <span>
                                    <span>Visitor Management</span>
                                </span>
                            }>

                            <Menu.Item key="request-form" icon={<PicCenterOutlined />}>
                                <Link to="/request-form"><span>Request Form</span></Link>
                            </Menu.Item>
                            <Menu.Item key="hod-approval" icon={<PicCenterOutlined />}>
                                <Link to="/hod-approval"><span>HOD Approval</span></Link>
                            </Menu.Item>
                            <Menu.Item key="hr-approval" icon={<PicCenterOutlined />}>
                                <Link to="/hr-approval"><span>HR Approval</span></Link>
                            </Menu.Item>
                            <Menu.Item key="security-panel" icon={<PicCenterOutlined />}>
                                <Link to="/security-panel"><span>Security Panel</span></Link>
                            </Menu.Item>
                            <Menu.Item key="visitor-card" icon={<PicCenterOutlined />}>
                                <Link to="/visitor-card"><span>visitor card</span></Link>
                            </Menu.Item>
                            <Menu.Item key="visitor-statusreport" icon={<PicCenterOutlined />}>
                                <Link to="/visitor-statusreport"><span>visitor status report</span></Link>
                            </Menu.Item>
                            <Menu.Item key="visitor-dashboard" icon={<PicCenterOutlined />}>
                                <Link to="/visitor-dashboard"><span>Dashboard</span></Link>
                            </Menu.Item>

                        </SubMenu>

                    } */}
                    {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                        <SubMenu
                            key="canteenmanagement" icon={<FontAwesomeIcon icon={faUtensils} />}
                            title={
                                <span>
                                    <span>Canteen Management</span>
                                </span>
                            }
                        >

                            <Menu.Item key="/device-view" icon={<PicCenterOutlined />}>
                                <Link to="/device-view"><span>Devices</span> </Link>
                            </Menu.Item>
                            <Menu.Item key="/freebies-view" icon={<PicCenterOutlined />}>
                                <Link to="/freebies-view"><span>Freebies</span> </Link>
                            </Menu.Item>
                            <Menu.Item key="/employeetokens-grid" icon={<PicCenterOutlined />}>
                                <Link to="/employeetokens-grid"><span>Employee Tokens</span> </Link>
                            </Menu.Item>
                            <Menu.Item key="/scan-token" icon={<ScanOutlined />}>
                                <Link to="/scan-token"><span>Scan Token</span> </Link>
                            </Menu.Item>
                        </SubMenu>
                    } */}
                    {/* {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                        <SubMenu
                            key="ams" icon={<AppstoreOutlined />}
                            title={
                                <span>
                                    <span>Asset Management</span>
                                </span>
                            }
                        >
                            <Menu.Item key="asset-dashboard" icon={<PieChartOutlined />}>
                                <Link to="asset-dashboard"><span>Dashboard</span></Link>
                            </Menu.Item>
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                                <SubMenu
                                    key="aseet" icon={<AppstoreOutlined />}
                                    title={
                                        <span>
                                            <span>Request and Transfer</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="view-asset-transfers" icon={<CalendarOutlined />}>
                                        <Link to="/view-asset-transfers"><span>Transfer</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="asset-requistion-grid" icon={<AppstoreAddOutlined />}>
                                        <Link to="/asset-requistion-grid"><span>Requistion</span></Link>
                                    </Menu.Item>
                                </SubMenu>

                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                                <SubMenu
                                    key="ams-asset" icon={<AppstoreOutlined />}
                                    title={
                                        <span>
                                            <span>Asset Management</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="assets-form" icon={<AppstoreOutlined />}>
                                        <Link to="/assets-form"><span>Add Asset</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="asset-location-mapping-grid" icon={<EnvironmentOutlined />}>
                                        <Link to="/asset-location-mapping-grid"><span>Location Mapping</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="asset-assignment" icon={<FormOutlined />}>
                                        <Link to="/asset-assignment"><span>Assignment</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="asset-maintainance" icon={<SettingOutlined />}>
                                        <Link to="/asset-maintainance"><span> Maintenance</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="asset-decommission" icon={<DeleteOutlined />}>
                                        <Link to="/asset-decommission"><span>Retire</span></Link>
                                    </Menu.Item>
                                </SubMenu>

                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                                <SubMenu
                                    key="inventory" icon={<FontAwesomeIcon icon={faBoxesStacked} />}
                                    title={
                                        <span>
                                            <span>Inventory</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="assets-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/assets-grid"><span>Assets</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="asset-history-report" icon={<HistoryOutlined />}>
                                        <Link to="/asset-history-report"><span>History</span></Link>
                                    </Menu.Item>

                                </SubMenu>


                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                                <SubMenu
                                    key="ams-service" icon={<SettingOutlined />}
                                    title={
                                        <span>
                                            <span>Asset Service</span>
                                        </span>
                                    }
                                >


                                    <Menu.Item key="asset-service-grid" icon={<SolutionOutlined />}>
                                        <Link to="/asset-service-grid"><span>Service</span></Link>
                                    </Menu.Item>

                                    <Menu.Item key="asset-service-calender" icon={<CalendarOutlined />}>
                                        <Link to="/asset-service-calender"><span>Service Calender</span></Link>
                                    </Menu.Item>

                                </SubMenu>


                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                                <SubMenu
                                    key="ams-sale" icon={<SettingOutlined />}
                                    title={
                                        <span>
                                            <span>Sales</span>
                                        </span>
                                    }
                                >


                                    <Menu.Item key="asset-sale-grid" icon={<AppstoreAddOutlined />}>
                                        <Link to="/asset-sale-grid"><span>Asset Sale</span></Link>
                                    </Menu.Item>


                                </SubMenu>


                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                                <SubMenu
                                    key="ams-audit" icon={<SettingOutlined />}
                                    title={
                                        <span>
                                            <span>Audit</span>
                                        </span>
                                    }
                                >

                                    <Menu.Item key="location-audit-form" icon={<AppstoreAddOutlined />}>
                                        <Link to="/location-audit-form"><span>Audit Form</span></Link>
                                    </Menu.Item>


                                </SubMenu>


                            }
                            {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SR_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_SALES_MANAGER)) &&
                                <SubMenu
                                    key="License" icon={<MoneyCollectOutlined />}
                                    title={
                                        <span>
                                            <span>License</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="license-view" icon={<PicCenterOutlined />}>
                                        <Link to="/asset-license-view"><span>License</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }


                            <Menu.Item key="asset-purchase-dashboard" icon={<PieChartOutlined />}>
                                <Link to="asset-purchase-dashboard"><span>Assets Dashboard</span></Link>
                            </Menu.Item>
                        </SubMenu>
                    } */}
                     {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON)) &&
                     <>
                    {
                        <SubMenu
                            key="sales_masters" icon={<MoneyCollectOutlined />}
                            title={
                                <span>
                                    <span>Finance</span>
                                </span>
                            }
                        >
                            <Menu.Item key="purchase-product-form" icon={<PicCenterOutlined />}>
                                <Link to="/purchase-product-form"><span>Product Purchase Form</span></Link>
                            </Menu.Item>
                            <Menu.Item key="collections" icon={<PicCenterOutlined />}>
                                <Link to="/collections"><span>Collections</span></Link>
                            </Menu.Item>
                            <Menu.Item key="expenses-logistics-view" icon={<BookOutlined />}>
                                    <Link to="/expenses-logistics-view"><span>Expenses</span></Link>
                                </Menu.Item>

<Menu.Item key="payables" icon={<PicCenterOutlined />}>
                                <Link to="/payables"><span>Payables</span></Link>
                            </Menu.Item>
                        </SubMenu>
                        
                    }
                    </>
                }
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.UNIT_PACKING_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                        <SubMenu
                            key="reports" icon={<EditOutlined />}
                            title={
                                <span>
                                    <span>Reports</span>
                                </span>
                            }
                        >
                             {
                                ( (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)) &&
                                <SubMenu
                                    key="EnquiryManagementReport" icon={<MoneyCollectOutlined />}
                                    title={
                                        <span>
                                            <span>Enquiry Management</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="/enquiry-management-report" icon={<PicCenterOutlined />}>
                                        <Link to="/enquiry-management-report"><span>Unapproved Enquiries Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/enquiry-complete-management-report" icon={<PicCenterOutlined />}>
                                        <Link to="/enquiry-complete-management-report"><span>Enquiry Management Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key='/product-grade-analysis-report' icon={<PicCenterOutlined/>}>
                                        <Link to='/product-grade-analysis-report'>Product And Grade Price Analysis Report</Link>
                                    </Menu.Item>
                                    <Menu.Item key="pending-order-summary-report" icon={<PicCenterOutlined />}>
                                        <Link to="/pending-order-summary-report"><span>Pending Order Summary</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="order-book-report" icon={<PicCenterOutlined />}>
                                        <Link to="/order-book-report"><span>Order Book Schedule Report</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }
                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ENQUIRY_PERSON)) &&

                                <SubMenu
                                    key="SO" icon={<MoneyCollectOutlined />}
                                    title={
                                        <span>
                                            <span>SO</span>
                                        </span>
                                    }
                                >
                                    {/* <Menu.Item key="sale-order-report" icon={<PicCenterOutlined />}>
                                        <Link to="/sale-otder-report"><span>Sale Order Report</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="transferred-saleorders-report" icon={<PicCenterOutlined />}>
                                        <Link to="/transferred-saleorders-report"><span>Transferred SO's Report</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="saleorder-abstract-report" icon={<PicCenterOutlined />}>
                                        <Link to="/saleorder-abstract-report"><span> SO Abstract </span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="saleorder-history-report" icon={<PicCenterOutlined />}>
                                        <Link to="/saleorder-history-report"><span> SO History </span></Link>
                                    </Menu.Item> */}

                                    <Menu.Item key="pending-orders-report" icon={<PicCenterOutlined />}>
                                        <Link to="/pending-orders-report"><span>Pending Orders Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="shipped-orders-report" icon={<PicCenterOutlined />}>
                                        <Link to="/shipped-orders-report"><span>Shipped Orders Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="buyer-wise-orders-report" icon={<PicCenterOutlined />}>
                                        <Link to="/buyer-wise-orders-report"><span>Order Planning</span></Link>
                                    </Menu.Item>
                                   
                                    <Menu.Item key="overdue-pending-order-report" icon={<PicCenterOutlined />}>
                                        <Link to="/overdue-pending-order-report"><span>Overdue Pending Orders Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="product-wise-stock-report" icon={<PicCenterOutlined />}>
                                        <Link to="/product-wise-stock-report"><span>Orders In Hand Report</span></Link>
                                    </Menu.Item>
                                   
                                    {/* <SubMenu
                                    key="Lot Wise Profitability" icon={<DropboxOutlined />}
                                    title={
                                        <span>
                                            <span>Lot Wise Profitability</span>
                                        </span>
                                    }
                                    >
                                    <Menu.Item key="day-wise-produciton-analysis" icon={<PicCenterOutlined />}>
                                        <Link to="/day-wise-produciton-analysis"><span>Day Wise Produciton Analysis</span></Link>
                                    </Menu.Item>
                                    </SubMenu> */}
                                </SubMenu>
                            }

                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.UNIT_PACKING_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER)) &&
                                <>

                                    <SubMenu
                                        key="Packing" icon={<DropboxOutlined />}
                                        title={
                                            <span>
                                                <span>Packing</span>
                                            </span>
                                        }
                                    >
                                        {
                                            ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER)) &&
                                            <>
                                                {/* <Menu.Item key="packing-bom-reprt" icon={<PicCenterOutlined />}>
                                                    <Link to="/packing-bom-reprt"><span>Packing Bom</span></Link>
                                                </Menu.Item> */}
                                                {/* <Menu.Item key="purchase-order-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/purchase-order-report"><span>Purchase Order </span></Link>
                                                </Menu.Item> */}
                                                <Menu.Item key="stock-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/stock-report"><span>Stock </span></Link>
                                                </Menu.Item>
                                                <Menu.Item key="stock-wise-summary-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/stock-wise-summary-report"><span> Stock Summary Report </span></Link>
                                                </Menu.Item>
                                                <Menu.Item key="dead-stock-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/dead-stock-report"><span> Dead Stock Report </span></Link>
                                                </Menu.Item>
                                                <Menu.Item key="store-consumption-summary-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/store-consumption-summary-report"><span> Store Consumption Summary Report </span></Link>
                                                </Menu.Item>


                                                {/* <Menu.Item key="grn-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/grn-report"><span>GRN</span></Link>
                                                </Menu.Item> */}

                                                {/* <Menu.Item key="so-packing-status-report" icon={<PicCenterOutlined />}>
                                    <Link to="/so-packing-report"><span>So Packing Status Report</span></Link>
                                </Menu.Item> */}
                                                {/* <Menu.Item key="/excess-inventory-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/excess-inventory-report"><span>Excess inventory report</span></Link>
                                                </Menu.Item> */}
                                                <Menu.Item key="/packing-stock-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/packing-stock-report"><span>Packing Stock report</span></Link>
                                                </Menu.Item>
                                                {/* <Menu.Item key="/re-classification-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/re-classification-report"><span>Re Classification Report</span></Link>
                                                </Menu.Item> */}
                                                {/* <Menu.Item key="grn-inspection-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/grn-inspection-report"><span>GRN Inspection Report</span></Link>
                                                </Menu.Item> */}
                                                      <Menu.Item key="store-consumption-report" icon={<PicCenterOutlined />}>
                                        <Link to="/store-consumption-report"><span>Store Consumption Report</span></Link>
                                    </Menu.Item>
                                            </>}

                                        {
                                            ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER)) &&
                                            <>
                                                {/* <Menu.Item key="/supply-performance-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/supply-performance-report"><span>Supplier Performance Report</span></Link>
                                                </Menu.Item> */}
                                            </>
                                        }

                                        {
                                            ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_CAPTAINS) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.UNIT_PACKING_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER)) &&
                                            <>
                                                {/* <Menu.Item key="so-packing-status" icon={<PicCenterOutlined />}>
                                                    <Link to="/so-packing-status"><span>SO Packing Status Report</span></Link>
                                                </Menu.Item> */}
                                                {/* <Menu.Item key="store-consumption-report" icon={<PicCenterOutlined />}>
                                                    <Link to="/store-consumption-report"><span>Store Consumption Report</span></Link>
                                                </Menu.Item>
                                                <Menu.Item key="store-return-req" icon={<PicCenterOutlined />}>
                                                    <Link to="/store-return-req"><span>Store Return Report</span></Link>
                                                </Menu.Item> */}
                                            </>
                                        }


                                    </SubMenu>
                                </>}

                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.INDENT_PERSON)) &&
                                <SubMenu
                                    key="RM" icon={<ContainerOutlined />}
                                    title={
                                        <span>
                                            <span>RM</span>
                                        </span>
                                    }
                                >
                                    {/* <Menu.Item key="rm-procurement-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-procurement-report"><span>RM Procurement Report</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="grn-abstract-report-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/grn-abstract-report-grid"><span>Count Wise Quantity Summary</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="indent-report" icon={<PicCenterOutlined />}>
                                        <Link to="/indent-report"><span>Indent Report</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="rm-rate-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-rate-report"><span>Rm Rates Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="quantity-deviation-report" icon={<PicCenterOutlined />}>
                                        <Link to="/quantity-deviation-report"><span>Quantity Deviation Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="purchase-analysis-report" icon={<PicCenterOutlined />}>
                                        <Link to="/purchase-analysis-report"><span>Purchase Analysis Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="month-wise-purchase-analysis-report" icon={<PicCenterOutlined />}>
                                        <Link to="/month-wise-purchase-analysis-report"><span>Month Wise Purchase Analysis Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="live-purchase-analysis-report" icon={<PicCenterOutlined />}>
                                        <Link to="/live-purchase-analysis-report"><span> Live Purchase Analysis Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rm-receiving-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-receiving-report"><span>RM Receiving Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rm-deflict-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-deflict-report"><span>RM Deficit Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rm-budget-variance-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-budget-variance-report"><span>RM Budget Variance Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="grn-invoice-report" icon={<PicCenterOutlined />}>
                                        <Link to="/grn-invoice-report"><span>Invoice Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rm-average-rate-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-average-rate-report"><span> Average RM Rate Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rm-indent-rejected-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-indent-rejected-report"><span> Indent Rejected Report</span></Link>
                                    </Menu.Item>
                                </SubMenu>}

                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PRODUCTION_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON) ||  (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.REWEIGHTMENT_PERSON)) &&
                                <SubMenu
                                    key="Production" icon={<RiseOutlined />}
                                    title={
                                        <span>
                                            <span>Production</span>
                                        </span>
                                    }
                                >
                                    {/* <Menu.Item key="/lot-tracking-report" icon={<PicCenterOutlined />}>
                                        <Link to="/lot-tracking-report"><span>Lot Tracking</span></Link>
                                    </Menu.Item> */}

                                    {/* <Menu.Item key="/production-log" icon={<PicCenterOutlined />}>
                                        <Link to="/production-log"><span>Production Log</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/production-inventory" icon={<PicCenterOutlined />}>
                                        <Link to="/production-inventory"><span>Production Inventory</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/production-inventory-operations" icon={<PicCenterOutlined />}>
                                        <Link to="/production-inventory-operations"><span>Operation Wise Inventory Report</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/operations-register" icon={<PicCenterOutlined />}>
                                        <Link to="/operations-register"><span>Operations Register</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/downtime-report" icon={<PicCenterOutlined />}>
                                        <Link to="/downtime-report"><span>Downtime Report</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="/soaking-analysis-report" icon={<PicCenterOutlined />}>
                                        <Link to="/soaking-analysis-report"><span>Soaking Analysis Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/grading-analysis-report" icon={<PicCenterOutlined />}>
                                        <Link to="/grading-analysis-report"><span>Grading Analysis Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/grading-summary-report" icon={<PicCenterOutlined />}>
                                        <Link to="/grading-summary-report"><span>Grading Summary Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/transportation-charges-report" icon={<PicCenterOutlined />}>
                                        <Link to="/transportation-charges-report"><span>Transportation Charges Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/worker-wise-wages-report" icon={<PicCenterOutlined />}>
                                        <Link to="/worker-wise-wages-report"><span>Worker Wise Wages Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/contractor-and-day-wise-report" icon={<PicCenterOutlined />}>
                                        <Link to="/contractor-and-day-wise-report"><span>Contractor & Day Wise</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/wages-payable-village-wise-report" icon={<PicCenterOutlined />}>
                                        <Link to="/wages-payable-village-wise-report"><span>Wages Payable Village Wise</span></Link>
                                    </Menu.Item>
                                    

                                </SubMenu>}


                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)) &&
                                <SubMenu
                                    key="Warehouse" icon={<FontAwesomeIcon icon={faWarehouse}  />}
                                    title={
                                        <span>
                                            <span>Warehouse</span>
                                        </span>
                                    }
                                >
                                    {/* <Menu.Item key="/stock-report-warehouse" icon={<PicCenterOutlined />}>
                                        <Link to="/stock-report-warehouse"><span>Stock Report</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/dead-stock-report-warehouse" icon={<PicCenterOutlined />}>
                                        <Link to="/dead-stock-report-warehouse"><span>Dead Stock Report</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/stock-in-reverse-report" icon={<PicCenterOutlined />}>
                                        <Link to="/stock-in-reverse-report"><span>Stock in Reverse Report</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="/stock-in-transactions" icon={<PicCenterOutlined />}>
                                        <Link to="/stock-in-transactions"><span>Stock in Transactions</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/stock-out-transaction" icon={<PicCenterOutlined />}>
                                        <Link to="/stock-out-transaction"><span>Stock Out Transactions</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/stock-summary-report" icon={<PicCenterOutlined />}>
                                        <Link to="/stock-summary-report"><span>Stock Summary Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/fg-stock-report" icon={<PicCenterOutlined />}>
                                        <Link to="/fg-stock-report"><span>FG Stock Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/fg-stock-transfer-report" icon={<PicCenterOutlined />}>
                                        <Link to="/fg-stock-transfer-report"><span>FG Stock Transfer Report</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="/dummy-packing-report" icon={<PicCenterOutlined />}>
                                        <Link to="/dummy-packing-report"><span>Dummy Packing Report</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="container-loading-report" icon={<FontAwesomeIcon icon={faBook} />}>
                                        <Link to="/container-loading-report"><span>Container Loading Report</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/locations-history-report" icon={<PicCenterOutlined />}>
                                        <Link to="/locations-history-report"><span>Locations History Report</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="repacking-reprocessing-report" icon={<FontAwesomeIcon icon={faBook} />}>
                                        <Link to="/repacking-reprocessing-report"><span> FG Repacking & Reprocessing Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="stock-valuation-report" icon={<FontAwesomeIcon icon={faBook} />}>
                                        <Link to="/stock-valuation-report"><span>Stock Valuation Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="stock-statement-report" icon={<FontAwesomeIcon icon={faBook} />}>
                                        <Link to="/stock-statement-report"><span>Stock Statement Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/product-purchase-report" icon={<PicCenterOutlined />}>
                                        <Link to="/product-purchase-report"><span>Purchase Report</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="/product-purchase-report" icon={<PicCenterOutlined />}>
                                        <Link to="/product-purchase-report"><span>Purchase Report</span></Link>
                                    </Menu.Item> */}
                                </SubMenu>}


                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PLANT_SALES_MANAGER)) &&
                                <SubMenu
                                    key="Logistics" icon={<FontAwesomeIcon icon={faTruckFast} />}
                                    title={
                                        <span>
                                            <span>Logistics</span>
                                        </span>
                                    }
                                >
                                    {/* {
                                        <Menu.Item key="container-report" icon={<FontAwesomeIcon icon={faTruckPickup} />}>
                                            <Link to="/container-report"><span>Container Report</span></Link>
                                        </Menu.Item>
                                    }
                                    <Menu.Item key="/shipment-status-report" icon={<PicCenterOutlined />}>
                                        <Link to="/shipment-status-report"><span>Shipment Status Report</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="/shipment-details-report" icon={<PicCenterOutlined />}>
                                        <Link to="/shipment-details-report"><span>Shipment Details Report</span></Link>
                                    </Menu.Item>
                                </SubMenu>}

                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="HRMS" icon={<UserOutlined />}
                                    title={
                                        <span>
                                            <span> HRMS </span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="/monthwise-report" icon={<PicCenterOutlined />}>
                                        <Link to="/monthwise-report"><span>Monthwise Employee Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/worker-monthwise-report" icon={<PicCenterOutlined />}>
                                        <Link to="/worker-monthwise-report"><span>Monthwise Workers Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/nmr-monthwise-report" icon={<PicCenterOutlined />}>
                                        <Link to="/nmr-monthwise-report"><span>Monthwise Nmr Workers Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/worker-incentive-report" icon={<PicCenterOutlined />}>
                                        <Link to="/worker-incentive-report"><span>Worker Incentive Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/NMR-incentive-report" icon={<PicCenterOutlined />}>
                                        <Link to="/NMR-incentive-report"><span>NMR Incentive Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/employee-working-hrs" icon={<PicCenterOutlined />}>
                                        <Link to="/employee-working-hrs"><span>DayWise Log Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/miscellaneous-report" icon={<PicCenterOutlined />}>
                                        <Link to="/miscellaneous-report"><span>Employee Miscellaneous Report</span></Link>
                                    </Menu.Item>

                                    {/* <Menu.Item key="/recruitment-report" icon={<PicCenterOutlined />}>
                                        <Link to="/recruitment-report"><span>Recruitment Report</span></Link>
                                    </Menu.Item> */}
                                    <Menu.Item key="/leavemanagement-report" icon={<PicCenterOutlined />}>
                                        <Link to="/leavemanagement-report"><span>Employee Leaves Report</span></Link>
                                    </Menu.Item>
                                    {/* <Menu.Item key="/emp-monthwise-attendance-report" icon={<PicCenterOutlined />}>
                                        <Link to="/emp-monthwise-attendance-report"><span>Employee Attendance Scorecard</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/criteria-not-matching-report" icon={<PicCenterOutlined />}>
                                        <Link to="/criteria-not-matching-report"><span>Criteria Not Matching Report</span></Link>
                                    </Menu.Item> */}
                                    {/* <Menu.Item key="/ot-report" icon={<PicCenterOutlined />}>
                                        <Link to="/ot-report"><span>OT Report</span></Link>
                                    </Menu.Item> */}
                                </SubMenu>
                            }

{
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&

                                <SubMenu
                                    key="Payroll" icon={<FontAwesomeIcon icon={faMoneyCheckDollar} /> }
                                    title={
                                        <span>
                                            <span>PayRoll</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="payroll-employee-report" icon={<PicCenterOutlined />}>
                                        <Link to="/payroll-employee-report"><span>Employee Pay Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="payroll-NMR-report" icon={<PicCenterOutlined />}>
                                        <Link to="/payroll-NMR-report"><span>NMR Pay Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="payroll--inHouse-report" icon={<PicCenterOutlined />}>
                                        <Link to="/payroll-inHouse-report"><span>In-House Pay Report</span></Link>
                                    </Menu.Item>
                                    
                                </SubMenu>
                            }


                            {/* {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="VMS" icon={<FontAwesomeIcon icon={faTruck}/>}
                                    title={
                                        <span>
                                            <span> VMS </span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="/visitor-report" icon={<PicCenterOutlined />}>
                                        <Link to="/visitor-report"><span>Visitor Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/visitor-inside-factory-report" icon={<PicCenterOutlined />}>
                                        <Link to="/visitor-inside-factory-report"><span>Visitor inside factory Report</span></Link>
                                    </Menu.Item>

                                </SubMenu>} */}
                            {/* {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="CANTEEN MANAGEMENT" icon={<FontAwesomeIcon icon={faUtensils} />}
                                    title={
                                        <span>
                                            <span>Canteen Management</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="/employee-tokens-report-grid" icon={<PicCenterOutlined />}>
                                        <Link to="/employee-tokens-report-grid"><span>Employee Tokens Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/summary-report" icon={<PicCenterOutlined />}>
                                        <Link to="/summary-report"><span>Freebies consumption Summary Report</span></Link>
                                    </Menu.Item>

                                </SubMenu>} */}
                            {/* {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="asset" icon={<AppstoreOutlined />}
                                    title={
                                        <span>
                                            <span>Asset Management </span>
                                        </span>
                                    }
                                >
                                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                        <SubMenu
                                            key="reports-ams" icon={<EditOutlined />}
                                            title={
                                                <span>
                                                    <span>Operational Reports</span>
                                                </span>
                                            }
                                        >

                                            <Menu.Item key="asset-report" icon={<AppstoreOutlined />}>
                                                <Link to="/asset-report"><span>Asset Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="asset-assignment-report" icon={<FormOutlined />}>
                                                <Link to="/asset-assignment-report"><span> Assignment Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="asset-maintenance" icon={<SettingOutlined />}>
                                                <Link to="/asset-maintenance"><span> Maintenance Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="racinformation" icon={<ProfileOutlined />}>
                                                <Link to="/racinformation"><span>RACI Matrix Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="abstract-report" icon={<FontColorsOutlined />}>
                                                <Link to="/abstract-report"><span>Abstract Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="decomissioned-assets-report" icon={<DeleteOutlined />}>
                                                <Link to="/decomissioned-assets-report"><span>Retired Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="asset-service-report" icon={<SolutionOutlined />}>
                                                <Link to="/asset-service-report"><span>Service Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="insurance-report" icon={<FontColorsOutlined />}>
                                                <Link to="/insurance-report"><span>Insurance Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="warranty-report" icon={<FontColorsOutlined />}>
                                                <Link to="/warranty-report"><span>Warranty Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="depreciation-report" icon={<FontColorsOutlined />}>
                                                <Link to="/depreciation-report"><span>Depreciation Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="vms-report" icon={<FontColorsOutlined />}>
                                                <Link to="/vms-report"><span>VM Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="checklist-report" icon={<FontColorsOutlined />}>
                                                <Link to="/checklist-report"><span>Checklist Report</span></Link>
                                            </Menu.Item>

                                        </SubMenu>
                                    }
                                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                        <SubMenu
                                            key="audit-reports" icon={<EditOutlined />}
                                            title={
                                                <span>
                                                    <span>Audit Reports</span>
                                                </span>
                                            }
                                        >

                                            <Menu.Item key="asset-audit-report" icon={<FontColorsOutlined />}>
                                                <Link to="/asset-audit-report"><span>Rented Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="purchased-not-assigned" icon={<FontColorsOutlined />}>
                                                <Link to="/purchased-not-assigned"><span>Purchased Un-Assigned</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="asset-service-date-report" icon={<FontColorsOutlined />}>
                                                <Link to="/asset-service-date-report"><span>Service Date Overdue Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="expired-date-assets-report" icon={<FontColorsOutlined />}>
                                                <Link to="/expired-date-assets-report"><span>Expired Date Assets Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="employeeinactive-report" icon={<FontColorsOutlined />}>
                                                <Link to="/employeeinactive-report"><span>Employee InActive Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="audit-report" icon={<FontColorsOutlined />}>
                                                <Link to="/audit-report"><span>Audit Report</span></Link>
                                            </Menu.Item>
                                            <Menu.Item key="asset-sale-report" icon={<FontColorsOutlined />}>
                                                <Link to="/asset-sale-report"><span>Asset Sale Report</span></Link>
                                            </Menu.Item>

                                        </SubMenu>
                                    }


                                </SubMenu>} */}
                             {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)|| (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON)) &&
                                <SubMenu
                                    key="FinanceReport" icon={<MoneyCollectOutlined />}
                                    title={
                                        <span>
                                            <span>Finance</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="/receivables-summary-report" icon={<PicCenterOutlined />}>
                                        <Link to="/receivables-summary-report"><span> Receivables summary Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/expected-receivables-report" icon={<PicCenterOutlined />}>
                                        <Link to="/expected-receivables-report"><span>  Expected Receivables Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/receivables-details-report" icon={<PicCenterOutlined />}>
                                        <Link to="/receivables-details-report"><span> Receivables Details Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/export-receivables-report" icon={<PicCenterOutlined />}>
                                        <Link to="/export-receivables-report"><span> Export Receivables Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/export-receivables-aging-wise-report" icon={<PicCenterOutlined />}>
                                        <Link to="/export-receivables-aging-wise-report"><span> Export Receivables Aging Wise Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/rodtep-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rodtep-report"><span> RODTEP Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/rodtep-abstract-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rodtep-abstract-report"><span>  Abstract RODTEP Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/duty-draw-back-report" icon={<PicCenterOutlined />}>
                                        <Link to="/duty-draw-back-report"><span>  Duty Draw Back Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/abstract-duty-draw-back-report" icon={<PicCenterOutlined />}>
                                        <Link to="/abstract-duty-draw-back-report"><span>  Abstract Duty Draw Back Report</span></Link>
                                    </Menu.Item>
                                     <Menu.Item key="/igst-aging-report" icon={<PicCenterOutlined />}>
                                        <Link to="/igst-aging-report"><span> IGST Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/igst-report" icon={<PicCenterOutlined />}>
                                        <Link to="/igst-report"><span>Abstract IGST Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/invoice-against-aging-report" icon={<PicCenterOutlined />}>
                                        <Link to="/invoice-against-aging-report"><span>Invoice Payable Aging wise Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/farmer-payable-aging-report" icon={<PicCenterOutlined />}>
                                        <Link to="/farmer-payable-aging-report"><span> Farmer Payable Aging Wise Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/vendor-payable-aging-report" icon={<PicCenterOutlined />}>
                                        <Link to="/vendor-payable-aging-report"><span> Vendor Payable Aging Wise Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/budget-variance-report" icon={<PicCenterOutlined />}>
                                        <Link to="/budget-variance-report"><span> Budget Variance Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/vendorWise-tax-deduction" icon={<PicCenterOutlined />}>
                                        <Link to="/vendorWise-tax-deduction"><span> Vendor Tax Deduction Report</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }

                            {
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.FINANCE_PERSON) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.WAREHOUSE_MANAGER)) &&
                                <SubMenu
                                    key="MisReports" icon={<FontAwesomeIcon icon={faFileInvoice} />} 
                                    title={
                                        <span>
                                            <span>MIS Reports</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="/production-analysis-report" icon={<PicCenterOutlined />}>
                                        <Link to="/production-analysis-report"><span>Production Yield Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/container-wise-abstract" icon={<PicCenterOutlined />}>
                                        <Link to="/container-wise-abstract"><span>Container Wise Abstract</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/day-wise-produciton-analysis" icon={<PicCenterOutlined />}>
                                        <Link to="/day-wise-produciton-analysis"><span>Day Wise Production Analysis</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/monthly-wise-shrimp" icon={<PicCenterOutlined />}>
                                        <Link to="/monthly-wise-shrimp"><span>Monthly Wise Shrimp Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/monthly-mis-report" icon={<PicCenterOutlined />}>
                                        <Link to="/monthly-mis-report"><span>Monthly MIS Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/production-summary-report" icon={<PicCenterOutlined />}>
                                        <Link to="/production-summary-report"><span>Production Summary Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key='summarised-report' icon={<PicCenterOutlined/>}>
                                        <Link to='summarised-report'>LotWise Summary Report</Link>
                                    </Menu.Item>
                                   
                                </SubMenu>
                            }

{
                                ((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN)) &&
                                <SubMenu
                                    key="history_reports" icon={<FontAwesomeIcon icon={faFileInvoice} />} 
                                    title={
                                        <span>
                                            <span>History Reports</span>
                                        </span>
                                    }
                                >
                                    <Menu.Item key="sale-order-report" icon={<PicCenterOutlined />}>
                                        <Link to="/sale-otder-report"><span>Sale Order Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="saleorder-abstract-report" icon={<PicCenterOutlined />}>
                                        <Link to="/saleorder-abstract-report"><span> SO Abstract </span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="purchase-order-report" icon={<PicCenterOutlined />}>
                                        <Link to="/purchase-order-report"><span>Purchase Order </span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="grn-report" icon={<PicCenterOutlined />}>
                                        <Link to="/grn-report"><span>GRN</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/excess-inventory-report" icon={<PicCenterOutlined />}>
                                        <Link to="/excess-inventory-report"><span>Excess inventory report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="grn-inspection-report" icon={<PicCenterOutlined />}>
                                        <Link to="/grn-inspection-report"><span>GRN Inspection Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/supply-performance-report" icon={<PicCenterOutlined />}>
                                        <Link to="/supply-performance-report"><span>Supplier Performance Report</span></Link>
                                    </Menu.Item>
                              
                                    <Menu.Item key="store-return-req" icon={<PicCenterOutlined />}>
                                        <Link to="/store-return-req"><span>Store Return Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="rm-procurement-report" icon={<PicCenterOutlined />}>
                                        <Link to="/rm-procurement-report"><span>RM Procurement Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/production-inventory" icon={<PicCenterOutlined />}>
                                        <Link to="/production-inventory"><span>Production Inventory</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/production-inventory-operations" icon={<PicCenterOutlined />}>
                                        <Link to="/production-inventory-operations"><span>Operation Wise Inventory Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/stock-report-warehouse" icon={<PicCenterOutlined />}>
                                        <Link to="/stock-report-warehouse"><span>Stock Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/dead-stock-report-warehouse" icon={<PicCenterOutlined />}>
                                        <Link to="/dead-stock-report-warehouse"><span>Dead Stock Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="/dummy-packing-report" icon={<PicCenterOutlined />}>
                                        <Link to="/dummy-packing-report"><span>Dummy Packing Report</span></Link>
                                    </Menu.Item>
                                    <Menu.Item key="container-loading-report" icon={<FontAwesomeIcon icon={faBook} />}>
                                        <Link to="/container-loading-report"><span>Container Loading Report</span></Link>
                                    </Menu.Item>
                                    {
                                        <Menu.Item key="container-report" icon={<FontAwesomeIcon icon={faTruckPickup} />}>
                                            <Link to="/container-report"><span>Container Report</span></Link>
                                        </Menu.Item>
                                    }
                                    <Menu.Item key="/shipment-status-report" icon={<PicCenterOutlined />}>
                                        <Link to="/shipment-status-report"><span>Shipment Status Report</span></Link>
                                    </Menu.Item>
                                </SubMenu>
                            }

                           

                           
                        </SubMenu>
                    }
                </Menu>
            </Sider>

            <Layout
                style={{ marginLeft: collapsed ? 80 : 230 }}
            >
                <Header style={{
                    background: '#fff',
                    padding: 0
                }} className='noprint' >

                    <div className="ant-pro-global-header">
                        <div className="samllLogo">
                            <img style={{ display: collapsed ? 'block' : 'none' }} src={logo} />
                        </div>
                        <span className="ant-pro-global-header-trigger">
                            <MenuFoldOutlined
                                className="trigger"
                                type={collapsed ? 'menu-unfold' : 'menu-unfold'}
                                onClick={toggle}
                            />
                        </span>

                        <span>

                            <Button type="primary" style={{ float: 'right' }} onClick={logOut} ><ExportOutlined /><span className="l-rem">logout</span></Button>
                        </span>
                        <span ><Button style={{ float: 'right', border: 'white' }}>Hello! {username === '' ? user_name_local : props.user.user_data.username}</Button></span>

                        <span>
                            <Avatar icon={<UserOutlined />} />
                        </span>

                        {/* Advanced Search
                        <span> <Search
                            placeholder="Search here"
                            onSearch={value => console.log(value)}
                            style={{ width: 200, float: 'right', marginRight: '5%' }}
                        />
                        </span> */}
                    </div>
                </Header>

                <Content
                    style={{
                        margin: '5px 5px',
                        padding: 8,
                        background: '#fff',
                        minHeight: 280,
                        overflow: 'scroll',
                    }}
                >


                    <Route exact path="/down-time-tracking-form" render={props => <DownTimeTrackingForm downtimeTrackingData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }} />}
                    />

                    {/* <Route exact path="/unitcode-view" component={UnitCodeGrid} />
                    <Route exact path="/unitcode-form" component={UnitCodeForm} /> */}

                    <Route exact path="/saleorderprocesstypes-view" component={SaleOrderProcessTypesGrid} />
                    <Route exact path="/saleorderprocesstypes-form" render={props => <SaleOrderProcessTypesForm saleorderData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }}
                    />} />

                    <Route exact path="/upload-insurance" component={InsuranceUpload} />
                    <Route exact path="/ot-details" component={otDetails} />
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.HO_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER)) &&
                        <>
                            <Route exact path="/saleorder-bom" component={BomParameter} />
                        </>}

                    <Route exact path="/saleorder-bom-grid" component={BomParameterGrid} />
                    <Route exact path='/bom-detail-view' component={BomParameterDetailView} />
                    <Route exact path="/reporting" component={ReportingForm} />
                    <Route exact path="/operationlog-books-register" component={OperationsRegister} />
                    <Route exact path="/cus-invoice-detail-view" component={CusInvoice} />
                    <Route exact path="/common-invoice-detail-view" component={CommonInvoice} />
                    <Route exact path="/plant-packing-list-view" component={PackingList} />
                    <Route exact path="/common-packing-list-view" component={CommonPackingList} />
                    <Route exact path="/shipping-instructions-view" component={ShippingInstructions} />

                    <Route exact path="/commercial-packing-list-view" component={CommercialPackingList} />
                    <Route exact path="/commercial-invoice-view" component={CommercialInvoice} />
                    <Route exact path="/freigst-invoice" component={FreigstInvoice} />
                    <Route exact path="/plant-invoice" component={PlantInvoice} />
                    <Route exact path="/plant-packing-list" component={PlantPackingList} />
                    <Route exact path="/po-print-view" component={PoPrint} />
                    <Route exact path="/isf-worksheet" component={IsfWorksheet} />
                    {((JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.ADMIN) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKAGING_SUPERVISOR) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER) || (JSON.parse(localStorage.getItem('role')) === EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER)) && <>
                        <Route exact path="/location-mapping" render={props => <LocationMappingForm
                        />
                        } />

                    </>}

                    <Route exact path="/transfer-print" component={TransferPrint} />
                    <Route exact path="/workstations-form" render={props => <WorkstationsForm workstationData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateWorkstation={(undefined => { })} />} />
                    <Route exact path="/soaking-material-detail-view" component={SoakingMaterialDetailView} />
                    <Route exact path="/soaking-tub" component={SoakingTubBulbIntegration} />
                    <Route exact path='/sub-plant-val-addition-report' component={SubPlantValAdditionsReport} />
                    {/* <Route exact path="/shippment-details-received-tab" component={ShippmentDetailsReceivedTabForm} /> */}
                    <Route exact path="/be-heading-sub-plant-history" component={BeheadingSubPlantHistory} />

                    <Route exact path="/soaking-reporting" component={SoakingReporting} />
                    <Route exact path="/report-subplant-operations" component={ReportSubPlantOperations} />
                    <Route exact path="/qa-qc-sample-detail-view" component={QaQcSampleDetailView} />
                    <Route exact path="/cooking-form" component={BlanchingCookingForm} />
                    {((
                        [
                            EmployeeRolesEnum.ADMIN,
                            EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                            EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                            EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.SUPER_ADMIN, EmployeeRolesEnum.PACKING_CAPTAINS
                        ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) ? <>
                        {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.SUPER_ADMIN, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.PACKAGING_SUPERVISOR, EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>

                                <Route exact path="/grn-detail-view/:id" component={GrnDetailviewGrid} />

                                <Route exact path='/grn-return-detail-view/:id' component={GrnReturnDetailView} />
                                <Route exact path="/po-detail-view/:id" render={props => <PoDetailViewPages />} />

                            </>}


                        {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.HO_PACKAGING_MANAGER,
                                EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER, EmployeeRolesEnum.PACKING_CAPTAINS, EmployeeRolesEnum.PACKAGING_SUPERVISOR
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>

                                <Route exact path="/stock-transfer-detail-view/:id" component={StockTransferDetailView} />
                            </>}
                        {/* {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.ASSISTANT_PACKAGING_MANAGER,
                                EmployeeRolesEnum.PACKING_WAREHOUSE_CONTROLLER,EmployeeRolesEnum.PACKING_CAPTAINS,EmployeeRolesEnum.PACKAGING_SUPERVISOR,EmployeeRolesEnum.UNIT_PACKING_CONTROLLER
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                                <Route exact path="/packing-stock-transfer" component={PackingStockTransfer} />

                            </>} */}

                        {((
                            [
                                EmployeeRolesEnum.ADMIN,
                                EmployeeRolesEnum.SENIOR_PACKAGING_MANAGER, EmployeeRolesEnum.HO_PACKAGING_MANAGER, EmployeeRolesEnum.PACKAGING_SUPERVISOR
                            ].indexOf(JSON.parse(localStorage.getItem('role')))) > -1) && <>
                                <Route exact path="/store-consumption-detail-view" component={StoreConsumptionDetailView} />

                                <Route exact path="/store-consumption-form" render={props => <StoreConsumptionForm
                                    isUpdate={false}
                                    closeForm={() => { }} />
                                } />

                                <Route exact path="/store-return-grid" component={StoreReturnGrid} />
                                <Route exact path="/store-return-detail-view" component={StoreReturnDetailView} />

                            </>}

                    </> : ''}
                    <Route exact path="/generate-pick-list" component={GeneratePickList} />
                    <Route exact path='/send-receive-transactions' component={SendAndReceiveTransactions} />
                    <Route exact path="/so-info-view" component={SoInfoView} />
                    <Route exact path="/lot-detail-view" component={LotDetailView} />
                    {/* <Route exact path="/stock-in-transactions" component={StockInTransactionsReport} /> */}



                    <Route exact path="/code-list-print" component={CodeListPrint} />
                    <Route exact path="/code-list-detailView" component={CodeListDetailView} />

                    <Route exact path="/dispatch-list-grid" component={dispatchlistgrid} />
                    <Route exact path="/so-info-view" component={SoInfoViewPages} />
                    <Route exact path="/temperature-log-form" render={props => <TemperatureLogForm temperatureData={undefined}
                        closeForm={() => { }}
                    />} />
                    <Route exact path='/detailed-view' component={VisitorDetailedView} />
                    <Route exact path="/whatsapp-usage-report" component={WhatsAppUsageReport} />

                    

                    <UsersRouting />
                    <ReportsRouting />
                    <DowntimeRouting />
                    <RmProcurementRoute />
                    <HrmsRoute />
                    <WarehouseRoute />
                    <AssetManagementRouting />
                    <VmsRouting />
                    <CmsRouting />
                    <LogisticsRoute /> 
                   
                    <SalesRoute />
                    <PackingRouting />
                    <QaQcRouting />
                    <DashboardRouting /> 
                    <ProductionRouting />
                    <MastersRoute /> 

                </Content>
                <Footer style={{ textAlign: 'center' }} className='noprint'>Design © {new Date().getUTCFullYear()} Created by Schemaxtech</Footer>
            </Layout>
        </Router>
    </Layout >
    )
});
export default BasicLayout
